import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setUserLoggedIn } from '../../store/User'
import './billing.css'
import Invoices from './Invoice';
import CreditCardList from './CreditCardList';
import Modal from "../Pages/ChatSetup/components/Modal";
import Subcription_Cancellation from './Subcription_Cancellation';
import billing from "../../api/billing";
import partnerBilling from "../../api/partnerBilling";
import MonthlyReengage from "./MonthlyReengage";
import config from "../../config";
import { Loader } from 'semantic-ui-react';
import WatchPageTutorial from '../CommonComponents/WatchPageTutorial';

const PARTNER_PAYWALL_TRACKING_PARAMS = {
    track_partner_paywall_viewed: true,
};

const formatBillingDisplayDate = (dateValue) => {
    if (!dateValue) return '';
    const raw = String(dateValue).trim();
    // Prefer date-only parsing to avoid timezone shifting Y-m-d values.
    const dateOnly = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
    const date = dateOnly
        ? new Date(Number(dateOnly[1]), Number(dateOnly[2]) - 1, Number(dateOnly[3]))
        : new Date(raw);
    if (Number.isNaN(date.getTime())) return '';
    return date.toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
    });
};

const parseCancellationDetails = (raw) => {
    if (!raw) return null;
    if (typeof raw === 'object') return raw;
    if (typeof raw !== 'string') return null;
    const trimmed = raw.trim();
    if (!trimmed || trimmed === 'null') return null;
    try {
        const parsed = JSON.parse(trimmed);
        return parsed && typeof parsed === 'object' ? parsed : null;
    } catch (_) {
        return null;
    }
};

const getDateOnlyTimestamp = (dateValue) => {
    if (!dateValue) return null;
    const raw = String(dateValue).trim();
    const dateOnly = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
    const date = dateOnly
        ? new Date(Number(dateOnly[1]), Number(dateOnly[2]) - 1, Number(dateOnly[3]))
        : new Date(raw);
    if (Number.isNaN(date.getTime())) return null;
    return new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
};

/**
 * Resolve PLG subscription display state for Current Subscription UI.
 * Backend keeps subscription_status=ACTIVE after cancel and stores end date in
 * cancellation_details.billing_end_date (falls back to next_billing_date / churn_date).
 *
 * hasPreviousSubscription: true only when the account had a real subscription before
 * (subscription_id, cancellation_details, or churn/cancel dates). Never-subscribed
 * users stay in "none" and do not see the ended panel.
 */
const resolveSubscriptionLifecycle = (userBillingDetail = {}) => {
    const cancellationDetails = parseCancellationDetails(userBillingDetail.cancellation_details);
    const status = String(userBillingDetail.subscription_status || '')
        .trim()
        .toUpperCase();
    const endDateRaw =
        cancellationDetails?.billing_end_date ||
        userBillingDetail.cancel_subscription_date ||
        userBillingDetail.churn_date ||
        null;
    const nextBillingDate = userBillingDetail.next_billing_date || null;
    const endTs = getDateOnlyTimestamp(endDateRaw || nextBillingDate);
    const today = new Date();
    const todayTs = new Date(today.getFullYear(), today.getMonth(), today.getDate()).getTime();
    const hasCancellation = Boolean(cancellationDetails);
    const isDeactive = status === 'DEACTIVE' || status === 'CANCELLED' || status === 'CANCELED';
    const hasPreviousSubscription = Boolean(
        userBillingDetail.subscription_id ||
        hasCancellation ||
        userBillingDetail.churn_date ||
        userBillingDetail.cancel_subscription_date
    );

    if (!hasCancellation && !isDeactive) {
        return {
            state: 'active',
            nextBillingDate,
            endDate: null,
            hasPreviousSubscription,
        };
    }

    if (hasCancellation && endTs != null && endTs >= todayTs) {
        return {
            state: 'cancelling',
            nextBillingDate: null,
            endDate: endDateRaw || nextBillingDate,
            hasPreviousSubscription: true,
        };
    }

    if (hasPreviousSubscription) {
        return {
            state: 'ended',
            nextBillingDate: null,
            endDate: endDateRaw || nextBillingDate,
            hasPreviousSubscription: true,
        };
    }

    // Never subscribed — treat as empty/choose-plan state (no ended panel).
    return {
        state: 'none',
        nextBillingDate: null,
        endDate: null,
        hasPreviousSubscription: false,
    };
};

class Billing extends Component {
    constructor( props ){
        super(props);
        this.state = {
            isUserSubscribes : false,
            user : props.user,
            creditcardsDetail:[] ,
            invoicesDetail:[] ,
            userBillingDetail : {},
            cardloader      : false,
            invoiceloader : true ,
            openRefileamountModel : false,
            openRefilelimitModel : false,
            openmodleTitle : "",
            openRefilelimitinput: "",
            openRefileAmountInput: "",
            openRefileError : "",
            refilLimitValue : null,
            refilAmountValue : null,
            refileSuccessNFailure : "",
            userlinktoken:"",
            next_invoice:0,
            // PLG Account Status
            isPlgAccount: false, // Determined by GetPlgUsage API
            isInTrial: false,
            plgTwilioPhone: '',
            // PLG Plan Change State
            showPlanChangeModal: false,
            selectedNewPlan: null,
            currentPlan: null, // Current PLG plan from database
            plgUsagePlanCode: null, // plan_code from getPlgUsage API
            plgUsagePlanPrice: 0,   // plan_price from getPlgUsage API
            trialNextPlan: null,    // init_plan from getPlgUsage — shown in banner when no active plan
            availablePlans: [],
            plansLoading: false,
            planDropdownOpen: false,
            plansError: null,
            planChangeError: null, // Error message for plan change modal
            planChangeSubmitting: false, // Loading state for plan change submit button
            autoReloadEnabled: false, // Automatic call reloads toggle
            isDowngrade: false, // Track if plan change is a downgrade
            // Proration Preview State
            proratedData: null, // Prorated charge/credit data from backend
            proratedLoading: false, // Loading state while fetching proration
            // Voice Add-ons State
            availableAddons: [],
            addonTransactions: [], // Store transactions from getVoiceAddons API
            nextPlanInfo: null, // Store next_plan info from getVoiceAddons API
            addonsLoading: false,
            addonsError: null,
            showAddonPurchaseModal: false,
            selectedAddon: null,
            addonPurchaseError: null,
            addonPurchaseSubmitting: false, // Loading state for addon purchase submit button
            // Message Modal State
            showMessageModal: false,
            messageModalType: 'success', // 'success' or 'error'
            messageModalTitle: '',
            messageModalMessage: '',
            messageModalRefreshOnClose: false, // when true, refresh PLG plan data after modal is dismissed
            pendingPlanCode: null, // plan code from last successful purchase/upgrade — used until APIs catch up
            // Tab lazy loading state
            activeTab: null,
            loadedTabs: {},
            monthlyUsageRefreshKey: 0,
            reactivateLoading: false,
        }
        this.myRef = React.createRef();
        this.creditCardListRef = React.createRef();
        this.monthlySubscriptionRef = React.createRef();
        this.scrollToMonthlySubscription = () => {
            this.setState(
                { activeTab: 'currentSubscription', loadedTabs: { ...this.state.loadedTabs, currentSubscription: true } },
                () => {
                    setTimeout(() => {
                        if (this.monthlySubscriptionRef.current) {
                            this.monthlySubscriptionRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
                        }
                        this.setState({ planDropdownOpen: true }, () => {
                            const dropdown = document.getElementById('plg_plan_dropdown');
                            if (dropdown) dropdown.focus();
                        });
                    }, 200);
                }
            );
        };
        this._billingRefreshId = 0;
        this._plansFetchId = 0;

    }

    getPlgPlanStorageKey = () => {
        const userId = this.props.user?.user_id;
        return userId ? `plg_active_plan_${userId}` : null;
    }

    storeActivePlgPlanCode = (planCode) => {
        const storageKey = this.getPlgPlanStorageKey();
        if (!storageKey || !planCode) {
            return;
        }

        sessionStorage.setItem(storageKey, JSON.stringify({
            code: planCode,
            updatedAt: Date.now(),
        }));
    }

    getStoredPlgPlanRecord = () => {
        const storageKey = this.getPlgPlanStorageKey();
        if (!storageKey) {
            return null;
        }

        try {
            const raw = sessionStorage.getItem(storageKey);
            return raw ? JSON.parse(raw) : null;
        } catch (error) {
            return null;
        }
    }

    getStoredPlgPlanCode = () => {
        return this.getStoredPlgPlanRecord()?.code || null;
    }

    clearStoredPlgPlanCode = () => {
        const storageKey = this.getPlgPlanStorageKey();
        if (storageKey) {
            sessionStorage.removeItem(storageKey);
        }
    }

    getKnownPlanCodeHint = () => {
        return this.state.pendingPlanCode || this.getStoredPlgPlanCode() || null;
    }

    syncUserBillingToStore = (updatedUserBillingDetail) => {
        if (!this.props.setUserLoggedIn || !updatedUserBillingDetail) {
            return;
        }

        this.props.setUserLoggedIn({
            user: {
                ...this.props.user,
                userBillingDetail: updatedUserBillingDetail,
            },
        });
    }

    applyResolvedPlanState = (resolvedBillingDetail, creditcardsDetail, invoicesDetail, next_invoice, currentPlan) => {
        const updatedUserBillingDetail = this.buildUpdatedUserBillingSnapshot(
            resolvedBillingDetail,
            creditcardsDetail,
            invoicesDetail,
            next_invoice
        );

        this.setState(prevState => ({
            user: {
                ...prevState.user,
                userBillingDetail: updatedUserBillingDetail,
            },
            userBillingDetail: resolvedBillingDetail,
            currentPlan,
            invoicesDetail,
            creditcardsDetail,
            next_invoice,
        }));

        this.syncUserBillingToStore(updatedUserBillingDetail);

        if (currentPlan?.code) {
           // this.storeActivePlgPlanCode(currentPlan.code);
        }
    }

    componentDidMount(){
        this.refreshData();
        this.initializeTooltips();
    }

    componentDidUpdate(prevProps) {
        this.initializeTooltips();

        if (!this.props.isActive) {
            return;
        }

        const becameActive = !prevProps.isActive && this.props.isActive;
        const billingRefreshRequested = prevProps.billingRefreshKey !== this.props.billingRefreshKey;
        const enteredBillingRoute = (
            prevProps.location?.pathname !== this.props.location?.pathname
            || prevProps.location?.search !== this.props.location?.search
        ) && new URLSearchParams(this.props.location?.search || '').get('tab') === 'billing';

        if (becameActive || billingRefreshRequested || enteredBillingRoute) {
            this.refreshData();
        }
    }

    resolvePlgBillingDetail = (billingDetail, plgResponse, knownPlanCode = null) => {
        const apiPlanCode = (billingDetail?.plg_plan || '').trim();
        const usagePlanCode = (plgResponse?.plg_plan || plgResponse?.plan_code || '').trim();
        const storedRecord = knownPlanCode
            ? { code: knownPlanCode, updatedAt: Date.now() }
            : this.getStoredPlgPlanRecord();
        const storedPlanCode = (storedRecord?.code || knownPlanCode || '').trim();

        let billingPlanCode = apiPlanCode || usagePlanCode || storedPlanCode;

        if (storedPlanCode && apiPlanCode && storedPlanCode !== apiPlanCode) {
            const ageMs = Date.now() - (storedRecord?.updatedAt || 0);
            if (ageMs < 10 * 60 * 1000) {
                billingPlanCode = storedPlanCode;
            } else {
                billingPlanCode = apiPlanCode;
                this.clearStoredPlgPlanCode();
            }
        } else if (storedPlanCode && !apiPlanCode) {
            billingPlanCode = storedPlanCode;
        }

        if (apiPlanCode && storedPlanCode && apiPlanCode === storedPlanCode) {
            this.clearStoredPlgPlanCode();
            // this.storeActivePlgPlanCode(apiPlanCode);
        }

        const hasPlan = plgResponse?.has_plan === true || Boolean(billingPlanCode);

        let resolvedBillingDetail = billingDetail || {};
        if (plgResponse?.has_plan === false && !billingPlanCode) {
            resolvedBillingDetail = { ...resolvedBillingDetail, plg_plan: '' };
        } else if (billingPlanCode) {
            const matchedPlan = this.normalizePlanFromList(this.state.availablePlans, billingPlanCode);
            resolvedBillingDetail = {
                ...resolvedBillingDetail,
                plg_plan: billingPlanCode,
                ...(matchedPlan ? {
                    voice_monthly_fee: matchedPlan.price,
                    mins_in_plan: matchedPlan.calls,
                } : {}),
            };
        }

        const planCode = (resolvedBillingDetail?.plg_plan || billingPlanCode || null);
        return { hasPlan, resolvedBillingDetail, planCode };
    }

    normalizePlanFromList = (plans, planCode) => {
        if (!planCode || !plans?.length) {
            return null;
        }

        const matchedPlan = plans.find(
            (plan) => (plan.plan_code === planCode) || (plan.code === planCode)
        );

        if (!matchedPlan) {
            return null;
        }

        return {
            plan_id: matchedPlan.plan_id || null,
            code: matchedPlan.plan_code || matchedPlan.code,
            calls: matchedPlan.calls_included || matchedPlan.calls,
            price: matchedPlan.recurring_price || matchedPlan.price,
            name: matchedPlan.plan_name || matchedPlan.name,
        };
    }

    buildUpdatedUserBillingSnapshot = (resolvedBillingDetail, creditcardsDetail, invoicesDetail, next_invoice) => ({
        ...this.props.user.userBillingDetail,
        user_billing_overview: [resolvedBillingDetail],
        cards: creditcardsDetail,
        invoices: invoicesDetail,
        next_invoice,
    })

    refreshData = () => {
        if( this.props.user.userBillingDetail.is_billing_record_available === 1 ){
            const refreshId = ++this._billingRefreshId;

            this.setState({ plansLoading: true, currentPlan: null });

            // Fetch fresh billing detail and PLG usage in parallel
            Promise.all([
                billing.GetPlgUsage({ user_id: this.props.user.user_id }),
                billing.GetUserBillingDetail({ user_id: this.props.user.user_id })
            ])
                .then(([plgResponse, billingResponse]) => {
                    if (refreshId !== this._billingRefreshId) {
                        return;
                    }
                   
                    const isPlgAccountFinal = plgResponse.status && plgResponse.is_plg_account === true;
                    const initialTab = isPlgAccountFinal ? 'currentSubscription' : 'all';

                    const freshBillingData = billingResponse?.status ? billingResponse : null;
                    const billingDetail = freshBillingData
                        ? freshBillingData.user_billing_overview[0]
                        : this.props.user.userBillingDetail.user_billing_overview[0];
                    const invoicesDetail = freshBillingData
                        ? freshBillingData.invoices
                        : this.props.user.userBillingDetail.invoices;
                    const creditcardsDetail = freshBillingData
                        ? freshBillingData.cards
                        : this.props.user.userBillingDetail.cards;
                    const next_invoice = freshBillingData
                        ? freshBillingData.next_invoice
                        : this.props.user.userBillingDetail.next_invoice;

                    const autoReloadEnabled = billingDetail?.automatic_call_reloads === 'y' || billingDetail?.automatic_call_reloads === 'Y';

                    const knownPlanCode = this.getKnownPlanCodeHint();
                    const { hasPlan, resolvedBillingDetail, planCode } = this.resolvePlgBillingDetail(
                        billingDetail,
                        plgResponse,
                        knownPlanCode
                    );
                    const effectiveHasPlan = hasPlan || Boolean((planCode || '').trim());
                    const updatedUserBillingDetail = this.buildUpdatedUserBillingSnapshot(
                        resolvedBillingDetail,
                        creditcardsDetail,
                        invoicesDetail,
                        next_invoice
                    );

                    
                    this.setState(prevState => ({
                        isPlgAccount: isPlgAccountFinal,
                        isInTrial: plgResponse?.is_in_trial === true || plgResponse?.is_in_trial === 1 || plgResponse?.is_in_trial === '1' || plgResponse?.is_in_trial === 'true',
                        user: {
                            ...prevState.user,
                            userBillingDetail: updatedUserBillingDetail,
                        },
                        userBillingDetail : resolvedBillingDetail,
                        invoicesDetail : invoicesDetail,
                        creditcardsDetail : creditcardsDetail,
                        next_invoice: next_invoice,
                        invoiceloader : false,
                        activeTab: prevState.activeTab || initialTab,
                        loadedTabs: Object.keys(prevState.loadedTabs).length > 0
                            ? prevState.loadedTabs
                            : { [initialTab]: true },
                        autoReloadEnabled: autoReloadEnabled,
                        plgTwilioPhone: plgResponse.twilio_phone || '',
                        plgUsagePlanCode: plgResponse.plan_code || planCode || null,
                        plgUsagePlanPrice: plgResponse.plan_price ?? 0,
                        // next_plan is set when plg_plan is empty (no subscription yet) — already an object.
                        // init_plan is set when plg_plan exists but user is still in trial
                        // (deferred subscription — billing starts at trial end) — comes as a plain string.
                        // Normalise init_plan string into the same object shape so banner label logic works.
                        trialNextPlan: plgResponse.next_plan
                            || (plgResponse.init_plan && typeof plgResponse.init_plan === 'string'
                                ? { plan_code: plgResponse.init_plan, plan_name: plgResponse.init_plan }
                                : plgResponse.init_plan)
                            || null,
                        monthlyUsageRefreshKey: prevState.monthlyUsageRefreshKey + 1,
                        pendingPlanCode: null,
                        currentPlan: null,
                    }), () => {
                        this.syncUserBillingToStore(updatedUserBillingDetail);

                        this.setloader();
                        if (isPlgAccountFinal) {
                            this.fetchPlgPlans(effectiveHasPlan, planCode, {
                                fetchId: refreshId,
                                creditcardsDetail,
                                invoicesDetail,
                                next_invoice,
                                resolvedBillingDetail,
                            });
                            this.fetchVoiceAddons();
                        } else {
                            this.setState({ plansLoading: false });
                        }
                    });

                    billing.GetUserLinktoken({user_id: this.props.user.user_id })
                    .then((userResp) => {
                        this.setState({ userlinktoken: userResp.usertoken });
                    });
                })
                .catch((error) => {
                    if (refreshId !== this._billingRefreshId) {
                        return;
                    }

                    console.error('Error refreshing billing data:', error);
                    // Fallback to props data if API calls fail
                    const initialTab = 'all';
                    const billingDetail = this.props.user.userBillingDetail.user_billing_overview[0];
                    const autoReloadEnabled = billingDetail?.automatic_call_reloads === 'y' || billingDetail?.automatic_call_reloads === 'Y';

                    this.setState({
                        isPlgAccount: false,
                        userBillingDetail : billingDetail,
                        invoicesDetail : this.props.user.userBillingDetail.invoices,
                        creditcardsDetail : this.props.user.userBillingDetail.cards,
                        next_invoice: this.props.user.userBillingDetail.next_invoice,
                        invoiceloader : false,
                        activeTab: this.state.activeTab || initialTab,
                        loadedTabs: Object.keys(this.state.loadedTabs).length > 0
                            ? this.state.loadedTabs
                            : { [initialTab]: true },
                        autoReloadEnabled: autoReloadEnabled
                    }, () => this.setloader());

                    billing.GetUserLinktoken({user_id: this.props.user.user_id })
                    .then((userResp) => {
                        this.setState({ userlinktoken: userResp.usertoken });
                    });
                });
    }
    }

    componentWillUnmount() {
        // Ensure body scroll is restored when component unmounts
        document.body.style.overflow = 'unset';
    }

    initializeTooltips = () => {
        // Initialize Bootstrap tooltips if jQuery and Bootstrap are available
        if (typeof window !== 'undefined' && window.$ && window.$('[data-toggle="tooltip"]').tooltip) {
            window.$('[data-toggle="tooltip"]').tooltip();
        }
    }

    // Fetch PLG plans directly from database (no cache needed - DB is already the cache)
    // hasPlan: authoritative value from GetPlgUsage API — if false, user has no active plan
    // activePlanCode: optional override — pass when state may not yet reflect the new plan code
    fetchPlgPlans = (hasPlan = true, activePlanCode = null, billingContext = null) => {
        const fetchId = billingContext?.fetchId ?? ++this._plansFetchId;
        let planCodeToMatch = (activePlanCode || this.getKnownPlanCodeHint() || '').trim() || null;
        const shouldResolvePlan = hasPlan || Boolean(planCodeToMatch);

       
        this.setState({ plansLoading: true, plansError: null });

        billing.GetPlgPlans({
            user_id: this.state.user.user_id,
            ...PARTNER_PAYWALL_TRACKING_PARAMS,
        })
            .then((response) => {
                if (billingContext?.fetchId != null) {
                    if (fetchId !== this._billingRefreshId) {
                        return;
                    }
                } else if (fetchId !== this._plansFetchId) {
                    return;
                }

                if (response.status && response.plans && response.plans.length > 0) {
                  

                    const responsePlanCode = (
                        response.current_plan_code
                        || response.active_plan_code
                        || response.user_plg_plan
                        || response.current_plan?.plan_code
                        || response.current_plan?.code
                        || ''
                    ).trim();

                    if (responsePlanCode) {
                        planCodeToMatch = responsePlanCode;
                    }

                    let normalizedCurrentPlan = null;

                    if (shouldResolvePlan) {
                        const userPlanCode = planCodeToMatch || billingContext?.resolvedBillingDetail?.plg_plan;
                        let currentPlan = null;

                        if (userPlanCode) {
                            currentPlan = response.plans.find(plan =>
                                (plan.plan_code === userPlanCode) || (plan.code === userPlanCode)
                            );
                         
                        }

                        if (currentPlan) {
                            normalizedCurrentPlan = this.normalizePlanFromList(
                                response.plans,
                                currentPlan.plan_code || currentPlan.code
                            );
                          
                        }
                    } else {
                        console.log('ℹ️ No active plan to display');
                    }

                    const baseBillingDetail = billingContext?.resolvedBillingDetail || this.state.userBillingDetail;
                    const resolvedBillingDetail = normalizedCurrentPlan
                        ? {
                            ...baseBillingDetail,
                            plg_plan: normalizedCurrentPlan.code,
                            voice_monthly_fee: normalizedCurrentPlan.price,
                            mins_in_plan: normalizedCurrentPlan.calls,
                        }
                        : baseBillingDetail;

                    this.setState({
                        availablePlans: response.plans,
                        currentPlan: normalizedCurrentPlan,
                        plansLoading: false,
                        plansError: null,
                    }, () => {
                        if (billingContext) {
                            this.applyResolvedPlanState(
                                resolvedBillingDetail,
                                billingContext.creditcardsDetail,
                                billingContext.invoicesDetail,
                                billingContext.next_invoice,
                                normalizedCurrentPlan
                            );
                        } else {
                            this.setState({
                                userBillingDetail: resolvedBillingDetail,
                            });
                            if (normalizedCurrentPlan) {
                               // this.storeActivePlgPlanCode(normalizedCurrentPlan.code);
                            }
                        }
                    });
                } else {
                    this.setState({
                        plansLoading: false,
                        plansError: response?.message || 'No plans available',
                    });
                }
            })
            .catch((error) => {
                if (billingContext?.fetchId != null) {
                    if (fetchId !== this._billingRefreshId) {
                        return;
                    }
                } else if (fetchId !== this._plansFetchId) {
                    return;
                }

                console.error('Error fetching PLG plans:', error);
                this.setState({ plansLoading: false, plansError: 'Failed to load plans' });
            });
    }

    // Fetch voice add-ons from database
    fetchVoiceAddons = () => {
      
        this.setState({ addonsLoading: true, addonsError: null });

        billing.GetVoiceAddons({ user_id: this.state.user.user_id })
            .then((response) => {
                if (response.status) {
               
                    this.setState({
                        availableAddons: response.addons || [],
                        addonTransactions: response.transactions || [],
                        nextPlanInfo: response.next_plan || null,
                        addonsLoading: false,
                        addonsError: null
                    }, () => {
                        // After add-ons are loaded, check if there's a saved addon_package
                        const savedAddonPackage = this.state.userBillingDetail?.addon_package;
                        if (savedAddonPackage && response.addons) {
                            const savedAddon = response.addons.find(a => a.addon_code === savedAddonPackage);
                            if (savedAddon) {
                         
                                this.setState({ selectedAddon: savedAddon });
                            }
                        }
                    });
                } else {
                    console.log('⚠️ No voice add-ons available');
                    this.setState({
                        availableAddons: [],
                        addonTransactions: [],
                        nextPlanInfo: null,
                        addonsLoading: false,
                        addonsError: response.message || 'No add-ons available'
                    });
                }
            })
            .catch((error) => {
                console.error('Error fetching voice add-ons:', error);
                this.setState({
                    availableAddons: [],
                    addonTransactions: [],
                    nextPlanInfo: null,
                    addonsLoading: false,
                    addonsError: 'Failed to load add-ons'
                });
            });
    }

    handleAddonSelect = (addon) => {


        // Allow any add-on selection - no downgrade restriction
        // Users can change their add-on preference at any time
        // Multiple add-ons can be purchased within the same billing cycle

        // Prevent body scroll when modal opens
        document.body.style.overflow = 'hidden';

        // Show confirmation modal
        this.setState({
            selectedAddon: addon,
            showAddonPurchaseModal: true,
            addonPurchaseError: null
        });
    }

    closeAddonPurchaseModal = () => {
        // Re-enable body scroll when modal closes
        document.body.style.overflow = 'unset';

        this.setState({
            showAddonPurchaseModal: false,
            selectedAddon: null,
            addonPurchaseError: null
        });
    }

    confirmAddonPurchase = () => {
        // Prevent multiple clicks
        if (this.state.addonPurchaseSubmitting) {
            return;
        }



        this.setState({ addonPurchaseSubmitting: true, addonPurchaseError: null });

        // Save addon_package preference to backend
        const updateData = {
            user_id: this.state.user.user_id,
            enabled: this.state.autoReloadEnabled,
            addon_package: this.state.selectedAddon.addon_code
        };

        billing.UpdateAutoReloadPreference(updateData)
            .then((response) => {
                if (response.status) {
                   

                    // Update billing detail with new addon_package
                    const updatedBillingDetail = {
                        ...this.state.userBillingDetail,
                        addon_package: this.state.selectedAddon.addon_code
                    };

                    // Re-enable body scroll when modal closes
                    document.body.style.overflow = 'unset';

                    this.setState({
                        addonPurchaseSubmitting: false,
                        showAddonPurchaseModal: false,
                        userBillingDetail: updatedBillingDetail,
                        addonPurchaseError: null,
                        showMessageModal: true,
                        messageModalType: 'success',
                        messageModalTitle: 'Add-on saved successfully',
                        messageModalMessage: `Auto-reload will now add ${this.state.selectedAddon.calls_included} calls automatically when triggered.`
                    });
                } else {
                    console.error('❌ Failed to save add-on package:', response.message);

                    // Re-enable body scroll
                    document.body.style.overflow = 'unset';

                    this.setState({
                        addonPurchaseSubmitting: false,
                        showAddonPurchaseModal: false,
                        selectedAddon: null,
                        showMessageModal: true,
                        messageModalType: 'error',
                        messageModalTitle: 'Failed to Save Add-On',
                        messageModalMessage: response.message || 'Failed to save add-on package'
                    });
                }
            })
            .catch((error) => {
                console.error('❌ Error saving add-on package:', error);

                // Re-enable body scroll
                document.body.style.overflow = 'unset';

                this.setState({
                    addonPurchaseSubmitting: false,
                    showAddonPurchaseModal: false,
                    selectedAddon: null,
                    showMessageModal: true,
                    messageModalType: 'error',
                    messageModalTitle: 'Error',
                    messageModalMessage: error.message || 'Network error occurred'
                });
            });
    }

    setloader = () => {
        this.setState({cardloader:true})
    }
    subscriptionError = ( state ) => {
        // Don't show error if data is still loading (invoiceloader is true)
        // This prevents showing "Please add payment method" before cards are fetched
        if (this.state.invoiceloader || this.state.cardloader) {
            return null;
        }

        let error = '';
        if( state.creditcardsDetail.length === 0 ){
            error = "Please add a payment method.";
        }
        if( error !== '' ){
            return <div className="alert alert-danger">{error}</div>
        }
    }
    changePrimaryCard = ( cardNo,expireson) => {
        let newuserBillingDetail = {...this.state.userBillingDetail,card_number:cardNo,card_expires_on:expireson};
        this.setState({
            ...this.state,
            userBillingDetail: newuserBillingDetail
        });
    }

    updateUserBillling=()=>{

        billing.GetUserBillingInfo( {user_id:this.state.userBillingDetail.user_id })
        .then((userResp) => {
            this.setState({
                ...this.state,
                userBillingDetail:userResp.data
            });
        });

        billing.GetUserCards( {user_id:this.state.userBillingDetail.zoho_customer_id})
        .then((userResp) => {
            if(userResp.msg=="done"){
                this.setState({creditcardsDetail:userResp.data});

            }
        });
        this.forceUpdate();
        this.subscriptionError( this.state );
    }

    updatecard = ( cards = []) => {
        this.subscriptionError( this.state );
        if( cards ){
            this.setState({
                ...this.state,
                creditcardsDetail:cards
            });
        }
    }
    closeModal = () => {
        this.setState({
            ...this.state,
            openRefileamountModel:false,
            openRefilelimitModel:false,
            refilAmountValue : null,
            refilLimitValue : null,
            openRefileError : '',
        })
        document.getElementById('refilAmountValueform').value = '';
        document.getElementById('refilLimitValueform').value = '';
    }
    openRefileModel = ( modelType ) => {
        if(modelType === 'amount'){
            this.setState({
                ...this.state,
                openRefileamountModel:true,
                openRefilelimitModel:false
            })

        }else if(modelType === 'limit'){
            this.setState({
                ...this.state,
                openRefileamountModel:false,
                openRefilelimitModel:true
            })
        }
    }

    onResponseRefileModification(){
        if(this.state.refileSuccessNFailure == 'success'){
            return <div class="alert alert-success" >{"Data updated succesfully. "}</div>;
        }else if(this.state.refileSuccessNFailure == 'failure'){
            return <div class="alert alert-danger">{"Please try after some time. "}</div>;
        }else{
            return "";
        }
    }
    onHandleChangeEvent( event ){
        let value = event.target.value;
        let field = event.target.name;
        let errormsg = '';
        let pattern = /^[0-9\.]+$/.test(value);
        value = parseFloat(value);
        if(!isNaN( value ) && value > 0 && pattern ) {
            errormsg = "";
        }else{
            errormsg = "Value should be interger and value is greater than 0.";
        }
        if(errormsg === ''){
            this.setState({...this.state,[field] :value,openRefileError :errormsg});
        }else{
            this.setState({...this.state,openRefileError :errormsg});
        }
    }
    onSubmitRefile( event,type ){
        event.preventDefault();
        let formdata = null;
        if( this.state.openRefileError === ''){
            if(type === 'limit'){
                if(this.state.refilLimitValue ){
                    formdata = {
                        refil_drop_amount:this.state.refilLimitValue,
                        user_id:this.state.userBillingDetail.user_id,
                        field : 'refil_drop_amount'
                    };
                    partnerBilling.modifyRefileRule(formdata).then(( userRes) => {
                        if(userRes.status){
                           
                            this.setState({
                                ...this.state,
                                userBillingDetail : {
                                    ...this.state.userBillingDetail,
                                    refil_drop_amount : userRes.data
                                },
                                refileSuccessNFailure :"success",
                                openRefileamountModel:false,openRefilelimitModel:false
                            },
                                () => setTimeout(() => {
                                    this.setState({...this.state,refileSuccessNFailure :""}
                                );
                            }, 10000));
                            window.scrollTo(0,0);
                        }

                    })
                }else{
                    return false;
                }
            }else{
                formdata = {refill_amount:this.state.refilAmountValue};
                /* this.setState({...this.state,refileSuccessNFailure :"failure",openRefileamountModel:false,openRefilelimitModel:false},() => setTimeout(() => {
                    this.setState({...this.state,refileSuccessNFailure :""});
                }, 10000)); */
                if(this.state.refilAmountValue ){
                    formdata = {
                        refill_amount:this.state.refilAmountValue,
                        user_id:this.state.userBillingDetail.user_id,
                        field : 'refill_amount'
                    };
                    partnerBilling.modifyRefileRule(formdata).then(( userRes) => {
                        if(userRes.status){
                            this.setState({
                                ...this.state,
                                userBillingDetail : {
                                    ...this.state.userBillingDetail,
                                    refill_amount : userRes.data
                                },
                                refileSuccessNFailure :"success",
                                openRefileamountModel:false,openRefilelimitModel:false
                            },
                                () => setTimeout(() => {
                                    this.setState({...this.state,refileSuccessNFailure :""}
                                );
                            }, 10000));
                            window.scrollTo(0,0);
                        }

                    })
                }else{
                    return false;
                }
            }
        }
        document.getElementById('refilAmountValueform').value = '';
        document.getElementById('refilLimitValueform').value = '';
        return false;
    }

    formRefilelimitModel = ( type ) => {
        if(type == 'limit'){
            return (
                <form onSubmit={(event) => this.onSubmitRefile( event,type )} >
                    <label>Current Value : ${this.state.userBillingDetail.refil_drop_amount}</label>
                    <input type="text" class="form-control" name="refilLimitValue" onChange={(event) => this.onHandleChangeEvent(event)} id="refilLimitValueform"/>
                    <span className="text-danger">{this.state.openRefileError}</span>
                    <div className="mt-3 d-flex justify-content-end">
                        <button onClick={() => this.closeModal()} className="btn btn-outline-secondary mx-3">Cancel</button>
                        <button type="submit" className="btn btn-primary">Update</button>
                    </div>
                </form>
            )
        }else{
            return (
                <form onSubmit={(event) => this.onSubmitRefile( event,type )} >
                    <label>Current Value : ${this.state.userBillingDetail.refill_amount}</label>
                    <input type="text" class="form-control" name="refilAmountValue" onChange={(event) => this.onHandleChangeEvent(event)}  id="refilAmountValueform"/>
                    <span className="text-danger">{this.state.openRefileError}</span>
                    <div className="mt-3 d-flex justify-content-end">
                        <button onClick={() => this.closeModal()} className="btn btn-outline-secondary mx-3">Cancel</button>
                        <button type="submit" className="btn btn-primary">Update</button>
                    </div>
                </form>
            )
        }
    }

    copyuserlink=(e)=>{
        //copy link
        var elem = document.querySelector('.copy--link');
        let link=config.serverBaseURL+"/subscribe_billing/"+ this.state.userlinktoken;
        var input = document.createElement('input');
        input.setAttribute('value', link);
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        elem.innerText="copied";

        setTimeout(() => {
            elem.innerText= "Copy Link"
        }, 1000);
    }

    // PLG Plan Change Methods
    handlePlanChange = (event) => {
        const selectedPlanCode = event.target.value;
        const currentPlanCode = this.state.plgUsagePlanCode ;
 

        // If empty selection (Choose a plan), do nothing
        if (!selectedPlanCode || selectedPlanCode.trim() === '') {
            console.log('ℹ️ Empty selection, no action needed');
            return;
        }

        // Only show modal if plan is different from current
        if (selectedPlanCode !== currentPlanCode) {
            // Find the selected plan from available plans by plan_code
            const newPlan = this.state.availablePlans.find(p => p.plan_code === selectedPlanCode);

            if (newPlan) {
                // Normalize plan object for consistent usage
                const normalizedPlan = {
                    plan_id: newPlan.plan_id || null,
                    code: newPlan.plan_code || newPlan.code,
                    calls: newPlan.calls_included || newPlan.calls,
                    price: newPlan.recurring_price || newPlan.price,
                    name: newPlan.plan_name || newPlan.name
                };

                // Check if user is trying to downgrade
                const currentCalls = this.state.currentPlan?.calls || 0;
                const newCalls = normalizedPlan.calls || 0;
                const isDowngrade = newCalls < currentCalls;

              

                // First plan and downgrades need no loader — no compute API call made ,this.state.plgUsagePlanCode
                const isFirstPlan = !this.state.userBillingDetail?.plg_plan;
                this.setState({
                    selectedNewPlan: normalizedPlan,
                    showPlanChangeModal: true,
                    planChangeError: null,
                    proratedLoading: !isDowngrade && !isFirstPlan,
                    proratedData: null,
                    isDowngrade: isDowngrade
                });

                // Prevent body scroll when modal opens
                document.body.style.overflow = 'hidden';

                // First plan purchase and downgrades need no compute API call
                if (!isDowngrade && !isFirstPlan) {
                    billing.CalculatePlanChangeCharge({
                        user_id: this.state.user.user_id,
                        plan_code: selectedPlanCode
                    })
                    .then((response) => {
                        if (response.status) {
                           
                            this.setState({
                                proratedData: response,
                                proratedLoading: false
                            });
                        } else {
                            console.error('❌ Failed to fetch prorated pricing:', response.message);
                            this.setState({
                                planChangeError: response.message || 'Failed to calculate pricing',
                                proratedLoading: false
                            });
                        }
                    })
                    .catch((error) => {
                        console.error('❌ Error fetching prorated pricing:', error);
                        this.setState({
                            planChangeError: 'Error calculating pricing. Please try again.',
                            proratedLoading: false
                        });
                    });
                }
            } else {
                console.warn('⚠️ Selected plan not found in available plans');
            }
        } else {
            console.log('ℹ️ Same plan selected, no modal needed');
        }
    }

    closeMessageModal = () => {
        const shouldRefresh = this.state.messageModalRefreshOnClose;
        const pendingPlanCode = this.state.pendingPlanCode;

        this.setState({
            showMessageModal: false,
            messageModalType: 'success',
            messageModalTitle: '',
            messageModalMessage: '',
            messageModalRefreshOnClose: false,
        }, () => {
            if (!shouldRefresh) return;
            this.refreshData();
            window.dispatchEvent(new CustomEvent('plg-plan-changed'));
        });
    }

    syncBillingAfterPlanChange = (knownPlanCode = null) => {
        if (knownPlanCode) {
            this.setState({ pendingPlanCode: knownPlanCode });
        }
        this.refreshData();
    }

    closePlanChangeModal = () => {
        // Re-enable body scroll when modal closes
        document.body.style.overflow = 'unset';

        this.setState({
            showPlanChangeModal: false,
            selectedNewPlan: null,
            planChangeError: null, // Clear error when closing modal
            proratedData: null, // Clear prorated data
            proratedLoading: false, // Reset loading state
            isDowngrade: false // Reset downgrade flag
        });
    }

    handleAutoReloadToggle = () => {
        const newValue = !this.state.autoReloadEnabled;
        this.setState({ autoReloadEnabled: newValue });

       

        // Save auto-reload preference to backend
        const updateData = {
            user_id: this.state.user.user_id,
            enabled: newValue,
            addon_package: this.state.selectedAddon ? this.state.selectedAddon.addon_code : null
        };

        billing.UpdateAutoReloadPreference(updateData)
            .then((response) => {
                if (response.status) {
                  
                } else {
                    console.error('❌ Failed to save auto-reload preference:', response.message);
                }
            })
            .catch((error) => {
                console.error('❌ Error saving auto-reload preference:', error);
            });
    }

    confirmPlanChange = () => {
        // Prevent multiple clicks
        if (this.state.planChangeSubmitting) {
            return;
        }

        // Check if user has a payment method (credit card)
        if (!this.state.creditcardsDetail || this.state.creditcardsDetail.length === 0) {
            console.error('❌ No payment method found');

            // Close the plan change modal and show error in message modal
            document.body.style.overflow = 'unset';

            this.setState({
                planChangeSubmitting: false,
                showPlanChangeModal: false,
                selectedNewPlan: null,
                planChangeError: null,
                proratedData: null,
                proratedLoading: false,
                showMessageModal: true,
                messageModalType: 'error',
                messageModalTitle: 'Payment Method Required',
                messageModalMessage: 'Please add a payment method before changing your plan. You can add a credit card in the Payment Methods section above.'
            });
            return;
        }

        console.log('🚀 Confirming plan change...');
        this.setState({ planChangeSubmitting: true, planChangeError: null });

        const subscriptionId = this.state.userBillingDetail.subscription_id;
        const hasSubscription = subscriptionId && subscriptionId.trim() !== '';

        

        const apiData = {
            user_id: this.state.user.user_id,
            plan_code: this.state.selectedNewPlan.code,
            subscription_id: subscriptionId || '',
            action: hasSubscription ? 'update' : 'create'
        };

        billing.ChangePlgPlan(apiData)
            .then(resp => {
                

                if (resp && resp.status) {
                    const isInitPlanUpdated = resp.action === 'init_plan_updated';
                    const isDowngrade = resp.action === 'downgrade_scheduled';
                    const newPlan = this.state.selectedNewPlan;

                    // Re-enable body scroll when modal closes
                    document.body.style.overflow = 'unset';

                    // Trial user with no active plan — only init_plan was saved in DB.
                    // Update trialNextPlan locally so the banner + dropdown reflect the
                    // new choice immediately. Do NOT touch plgUsagePlanCode / currentPlan.
                    if (isInitPlanUpdated) {
                        this.setState({
                            planChangeSubmitting: false,
                            showPlanChangeModal: false,
                            selectedNewPlan: null,
                            planChangeError: null,
                            proratedData: null,
                            proratedLoading: false,
                            trialNextPlan: {
                                plan_code: resp.plan_code || newPlan.code,
                                plan_name: resp.plan_name || newPlan.name,
                                calls_included: newPlan.calls,
                                price: newPlan.price,
                            },
                        });
                        return;
                    }

                    const message = isDowngrade
                        ? `Your subscription will switch to the ${newPlan.calls} calls/month plan in the next billing cycle.`
                        : hasSubscription
                            ? `Your subscription has been updated to ${newPlan.calls} calls/month`
                            : `Subscription created successfully with ${newPlan.calls} calls/month`;

                    const planChangeState = {
                        planChangeSubmitting: false,
                        showPlanChangeModal: false,
                        selectedNewPlan: null,
                        planChangeError: null,
                        proratedData: null,
                        proratedLoading: false,
                        showMessageModal: true,
                        messageModalType: 'success',
                        messageModalTitle: isDowngrade ? 'Downgrade scheduled successfully' : 'Subscription updated successfully',
                        messageModalMessage: message,
                        messageModalRefreshOnClose: true,
                    };

                    // Apply optimistic update so Monthly Subscription + Voice Usage reflect new plan immediately
                    if (!isDowngrade && newPlan) {
                        const confirmedPlanCode = resp.plan_code || resp.plg_plan || newPlan.code;
                        const updatedBillingDetail = {
                            ...this.state.userBillingDetail,
                            plg_plan: confirmedPlanCode,
                            voice_monthly_fee: newPlan.price,
                            mins_in_plan: newPlan.calls,
                            subscription_status: 'ACTIVE',
                            ...(resp.subscription_id ? { subscription_id: resp.subscription_id } : {}),
                        };

                        planChangeState.userBillingDetail = updatedBillingDetail;
                        planChangeState.currentPlan = {
                            plan_id: newPlan.plan_id || null,
                            code: confirmedPlanCode,
                            calls: newPlan.calls,
                            price: newPlan.price,
                            name: newPlan.name,
                        };
                        planChangeState.plgUsagePlanCode = confirmedPlanCode;
                        planChangeState.plgUsagePlanPrice = newPlan.price || 0;
                        planChangeState.pendingPlanCode = confirmedPlanCode;
                        planChangeState.monthlyUsageRefreshKey = this.state.monthlyUsageRefreshKey + 1;

                        this.setState(planChangeState, () => {
                           // this.storeActivePlgPlanCode(confirmedPlanCode);
                            this.syncUserBillingToStore(this.buildUpdatedUserBillingSnapshot(
                                updatedBillingDetail,
                                this.state.creditcardsDetail,
                                this.state.invoicesDetail,
                                this.state.next_invoice
                            ));
                        });
                        return;
                    }

                    this.setState(planChangeState);
                } else {
                    const errorMsg = resp?.message || 'Unknown error occurred';
                    console.error('❌ API Error:', errorMsg);

                    // Re-enable body scroll
                    document.body.style.overflow = 'unset';

                    this.setState({
                        planChangeSubmitting: false,
                        showPlanChangeModal: false,
                        selectedNewPlan: null,
                        proratedData: null,
                        proratedLoading: false,
                        showMessageModal: true,
                        messageModalType: 'error',
                        messageModalTitle: 'Plan Change Failed',
                        messageModalMessage: errorMsg
                    });
                }
            })
            .catch(err => {
                console.error('❌ Error changing plan:', err);

                const errorMessage = err.response?.data?.message || err.message || 'Network error occurred';

                // Re-enable body scroll
                document.body.style.overflow = 'unset';

                this.setState({
                    planChangeSubmitting: false,
                    showPlanChangeModal: false,
                    selectedNewPlan: null,
                    proratedData: null,
                    proratedLoading: false,
                    showMessageModal: true,
                    messageModalType: 'error',
                    messageModalTitle: 'Error',
                    messageModalMessage: errorMessage
                });
            });
    }

    // Format backend proration data for modal display
    formatBackendProration = (backendData) => {
        if (!backendData || !backendData.status) {
            return this.calculateProration(); // Fallback to client calculation
        }

        const { current_plan, new_plan, proration, billing_summary, change_type, date } = backendData;

        // Determine if this is first plan (no current plan means subscription creation)
        const isFirstPlan = !current_plan || !current_plan.plan_code;

        const proratedAmount = billing_summary.immediate_charge ?? 0;

        return {
            proratedAmount,
            creditAmount: change_type === 'downgrade' ? (billing_summary.immediate_credit ?? 0) : 0,
            newMonthlyPrice: billing_summary.next_billing_amount,
            currentPrice: current_plan?.price || 0,
            newPrice: new_plan?.price || 0,
            priceDifference: proration?.price_difference || 0,
            daysRemaining: proration?.days_remaining || 0,
            daysElapsed: proration?.days_elapsed || 0,
            totalDays: proration?.total_days || 0,
            nextBillingDate: billing_summary?.next_billing_date || null,
            isFirstPlan: isFirstPlan,
            currentCalls: current_plan?.calls || 0,
            newCalls: new_plan?.calls || 0,
            planName: new_plan?.plan_name || `${new_plan?.calls || 0} Calls Plan`,
            changeType: change_type,
            description: proration?.description || '',
            nextBillingDateFormatted: billing_summary?.next_billing_date
                ? new Date(billing_summary.next_billing_date).toLocaleDateString('en-US', {
                    month: 'long',
                    day: 'numeric',
                    year: 'numeric'
                })
                : null,
            todayDateFormatted: date
                ? new Date(date).toLocaleDateString('en-US', {
                    month: 'long',
                    day: 'numeric',
                    year: 'numeric'
                })
                : null
        };
    }

    calculateProration = () => {
        if (!this.state.selectedNewPlan) {
            return {
                proratedAmount: 0,
                newMonthlyPrice: 0,
                currentPrice: 0,
                priceDifference: 0,
                daysRemaining: 0,
                nextBillingDate: null,
                isFirstPlan: false
            };
        }

        // Check if this is the first plan (no existing plan)
        const currentPlanCode = this.state.userBillingDetail?.plg_plan;
        const isFirstPlan = !currentPlanCode || currentPlanCode.trim() === '';

        // Current plan details - use API data for PLG users
        const currentPrice = this.state.currentPlan?.price || parseFloat(this.state.userBillingDetail.voice_monthly_fee) || 0;
        const currentCalls = this.state.currentPlan?.calls || parseInt(this.state.userBillingDetail.mins_in_plan) || 0;

        // New plan details (from normalized selectedNewPlan)
        const newPrice = parseFloat(this.state.selectedNewPlan.price) || 0;
        const newCalls = parseInt(this.state.selectedNewPlan.calls) || 0;
        const planName = this.state.selectedNewPlan.name || `${newCalls} Calls Plan`;

        // Calculate days remaining in billing cycle
        let daysRemaining = 15; // Default fallback
        let nextBillingDate = null;

        if (this.state.userBillingDetail.next_billing_date) {
            try {
                const nextBilling = new Date(this.state.userBillingDetail.next_billing_date);
                const today = new Date();
                const diffTime = nextBilling - today;
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                daysRemaining = Math.max(0, diffDays);
                nextBillingDate = nextBilling.toLocaleDateString('en-US', {
                    month: 'long',
                    day: 'numeric',
                    year: 'numeric'
                });
            } catch (error) {
                console.warn('Error calculating days remaining:', error);
            }
        }

        // Calculate amount due today
        let proratedAmount = 0;

        if (isFirstPlan) {
            // First plan - charge full plan price immediately
            proratedAmount = parseFloat(newPrice.toFixed(2));
        } else {
            // Existing plan - calculate based on price difference
            const priceDifference = newPrice - currentPrice;

            // For upgrade: charge the full price difference (not prorated)
            // For downgrade: credit will be applied, but show as 0 for display
            if (priceDifference > 0) {
                // Upgrade: charge full price difference immediately
                proratedAmount = parseFloat(priceDifference.toFixed(2));
            }
        }

        // Determine if upgrade or downgrade (only applicable when there's an existing plan)
        const isUpgrade = !isFirstPlan && (newPrice > currentPrice);

        return {
            proratedAmount: proratedAmount,
            newMonthlyPrice: newPrice,
            currentPrice: currentPrice,
            priceDifference: Math.abs(newPrice - currentPrice),
            daysRemaining: daysRemaining,
            nextBillingDate: nextBillingDate,
            isUpgrade: isUpgrade,
            isFirstPlan: isFirstPlan,
            currentCalls: currentCalls,
            newCalls: newCalls,
            planName: planName
        };
    }

    // Handle tab switching with lazy loading
    handleTabSwitch = (event, tabName) => {
        event.preventDefault();

        this.setState(prevState => ({
            activeTab: tabName,
            loadedTabs: {
                ...prevState.loadedTabs,
                [tabName]: true
            },
            ...(tabName === 'monthlyUsage'
                ? { monthlyUsageRefreshKey: prevState.monthlyUsageRefreshKey + 1 }
                : {}),
        }));
    }
    handleReactivateSubscription = () => {
        const subscriptionId = this.state.userBillingDetail?.subscription_id;
        const userId = this.props.user?.user_id || this.state.userBillingDetail?.user_id;
        if (!subscriptionId || !userId || this.state.reactivateLoading) {
            this.setState({
                showMessageModal: true,
                messageModalType: 'error',
                messageModalTitle: 'Unable to reactivate',
                messageModalMessage: 'Subscription details are missing. Please refresh and try again.',
                messageModalRefreshOnClose: false,
            });
            return;
        }

        this.setState({ reactivateLoading: true });
        billing.reactivateSubscription({
            subscriptionId,
            userId,
        })
            .then((resp) => {
                if (resp && resp.msg === 'done') {
                    this.setState((prev) => ({
                        reactivateLoading: false,
                        userBillingDetail: {
                            ...(prev.userBillingDetail || {}),
                            subscription_status: 'ACTIVE',
                            cancellation_details: null,
                        },
                        showMessageModal: true,
                        messageModalType: 'success',
                        messageModalTitle: 'Subscription reactivated',
                        messageModalMessage: 'Your subscription has been reactivated successfully.',
                        messageModalRefreshOnClose: true,
                    }));
                    this.refreshData();
                    return;
                }
                this.setState({
                    reactivateLoading: false,
                    showMessageModal: true,
                    messageModalType: 'error',
                    messageModalTitle: 'Reactivation failed',
                    messageModalMessage:
                        (resp && resp.message) ||
                        'Unable to reactivate your subscription. Please try again or contact support.',
                    messageModalRefreshOnClose: false,
                });
            })
            .catch(() => {
                this.setState({
                    reactivateLoading: false,
                    showMessageModal: true,
                    messageModalType: 'error',
                    messageModalTitle: 'Reactivation failed',
                    messageModalMessage:
                        'Unable to reactivate your subscription. Please try again or contact support.',
                    messageModalRefreshOnClose: false,
                });
            });
    }

    getsubscription_link=()=>{
        if(this.state.userBillingDetail.subscription_status=="DEACTIVE" && this.state.userBillingDetail.subscription_id==""){
        return(
            <div className="row px-4 mb-4">
                <div className="col-sm-12">
                    <div className="subslink">
                        <a target="_blank" className='text-info' href={config.serverBaseURL+"/subscribe_billing/"+ this.state.userlinktoken}>Register and subscribe for billing</a>
                        <button className="btn btn-outline-dark badge ml-3 copy--link" onClick={(e)=>this.copyuserlink(e)}>Copy Link</button>
                    </div>
                </div>
            </div>
        );
        }
    }

    // Whether renderTrialSetupBanner() will render its own WatchPageTutorial + Cancel Subscription
    // actions block. CreditCardList's tab-header-actions must stay hidden whenever this is true,
    // otherwise both blocks render at once for live PLG accounts (duplicate buttons).
    trialBannerShowsActions() {
        const { isInTrial, isPlgAccount, userBillingDetail, creditcardsDetail } = this.state;
        if (!isPlgAccount) return false;
        if (isInTrial) return true;

        const hasSubscription = Boolean(userBillingDetail && userBillingDetail.subscription_id);
        const cards = Array.isArray(creditcardsDetail) ? creditcardsDetail : (creditcardsDetail?.cards || []);
        const hasCard = cards.length > 0;
        const subscriptionStatus = String(userBillingDetail?.subscription_status || '').trim().toUpperCase();
        if (hasSubscription && hasCard && subscriptionStatus === 'ACTIVE') return true;

        // Mirrors renderTrialSetupBanner()'s own hide condition: only fully-ended
        // accounts skip the fallback banner post-trial.
        const lifecycle = resolveSubscriptionLifecycle(userBillingDetail);
        return lifecycle.state !== 'ended';
    }

    renderTrialSetupBanner() {
        const { isInTrial, isPlgAccount, currentPlan, plgUsagePlanPrice, plgUsagePlanCode, creditcardsDetail, trialNextPlan, availablePlans, userBillingDetail } = this.state;
        if (!isPlgAccount) return null;

        const hasPlan = Boolean(currentPlan || plgUsagePlanCode);
        const hasSubscription = Boolean(userBillingDetail && userBillingDetail.subscription_id);
        const cards = Array.isArray(creditcardsDetail) ? creditcardsDetail : (creditcardsDetail?.cards || []);
        const hasCard = cards.length > 0;
        const subscriptionStatus = String(userBillingDetail?.subscription_status || '').trim().toUpperCase();
        // Live banner only replaces the trial banner once there's an active, paid subscription on file.
        const isLiveActive = !isInTrial && hasSubscription && hasCard && subscriptionStatus === 'ACTIVE';

        // Only hide the banner post-trial for accounts that actually cancelled/churned (ended only).
        // Cancelling accounts (hasCancellation but end date in the future) keep the banner visible
        // so we can show the subscription-ending state with a Reactivate button.
        const lifecycle = resolveSubscriptionLifecycle(userBillingDetail);
        const isCancelling = lifecycle.state === 'cancelling';
        if (!isInTrial && !isLiveActive && !isCancelling) {
            if (lifecycle.state === 'ended') {
                return null;
            }
        }

        const cancellationEndDateFormatted = isCancelling
            ? formatBillingDisplayDate(lifecycle.endDate)
            : null;

        let nextBillingDateFormatted = null;
        if (isLiveActive && !isCancelling && userBillingDetail?.next_billing_date) {
            try {
                const nextBilling = new Date(userBillingDetail.next_billing_date);
                if (!Number.isNaN(nextBilling.getTime())) {
                    nextBillingDateFormatted = nextBilling.toLocaleDateString('en-US', {
                        month: 'long',
                        day: 'numeric',
                        year: 'numeric',
                    });
                }
            } catch (error) {
                console.warn('Error formatting next billing date:', error);
            }
        }

        // Active plan label (when subscription exists)
        const price = currentPlan?.price || plgUsagePlanPrice;
        const calls = currentPlan?.calls;
        const label = price && calls
            ? `$${Number(price).toFixed(0)}/mo for ${calls} AI answered calls`
            : price
                ? `$${Number(price).toFixed(0)}/mo`
                : null;

        // init_plan / next_plan label — shown during trial for the plan that will activate.
        // trialNextPlan may be a full object (from next_plan) or have only plan_code (from init_plan).
        // Enrich with data from availablePlans if price/calls are missing.
        let enrichedNextPlan = trialNextPlan;
        if (trialNextPlan && (!trialNextPlan.price || !trialNextPlan.calls_included)) {
            const planCode = trialNextPlan.plan_code;
            const match = Array.isArray(availablePlans)
                ? availablePlans.find(p => p.plan_code === planCode)
                : null;
            if (match) {
                enrichedNextPlan = {
                    ...trialNextPlan,
                    price: match.price || match.recurring_price,
                    calls_included: match.calls_included || match.calls,
                    plan_name: match.name || match.plan_name || trialNextPlan.plan_name,
                };
            }
        }
        const nextPlanLabel = enrichedNextPlan
            ? (enrichedNextPlan.price && enrichedNextPlan.calls_included
                ? `$${Number(enrichedNextPlan.price).toFixed(0)}/mo for ${enrichedNextPlan.calls_included} AI answered calls`
                : enrichedNextPlan.plan_name || enrichedNextPlan.plan_code || null)
            : null;

        const addCardLink = (
            <button
                type="button"
                className="trial-setup-banner__change-plan-link btn-link"
                onClick={() => this.creditCardListRef.current && this.creditCardListRef.current.triggerAddCard()}
            >
                Add a payment method
            </button>
        );

        return (
            <div className="trial-setup-banner-row">
                <div className="trial-setup-banner">
                    <div className={`trial-setup-banner__left${isLiveActive ? ' trial-setup-banner__left--live' : ''}`}>
                        <div className="trial-setup-banner__icon">
                            <i className="fa fa-calendar-alt" aria-hidden="true"></i>
                        </div>
                        <div>
                            {isCancelling ? (
                                <div className="trial-setup-banner__live-text">
                                    <div className="trial-setup-banner__heading-label">Subscription Ending</div>
                                    <div className="trial-setup-banner__heading-caption">
                                        Your subscription will end on{' '}
                                        <span className="trial-setup-banner__heading-date" style={{display:'inline', margin:0}}>
                                            {cancellationEndDateFormatted || '—'}
                                        </span>
                                    </div>
                                    <div className="trial-setup-banner__heading-caption" style={{marginTop: '6px'}}>
                                        You will lose access to your subscription features after this date.
                                    </div>
                                </div>
                            ) : isLiveActive ? (
                                <div className="trial-setup-banner__live-text">
                                    <div className="trial-setup-banner__heading-label">Next Billing Date</div>
                                    <div className="trial-setup-banner__heading-date">{nextBillingDateFormatted || '—'}</div>
                                    <div className="trial-setup-banner__heading-caption">We'll send your invoice shortly before this date.</div>
                                </div>
                            ) : (
                                <>
                            <h4 className="trial-setup-banner__heading">Complete your trial setup</h4>
                            <p className="trial-setup-banner__body">
                                {hasPlan && label
                                    ? <>You're on the {label} plan.<br /></>
                                    : nextPlanLabel
                                        ? <>The {nextPlanLabel} plan will activate when your trial ends.<br /></>
                                        : <>You don't have a plan yet.<br /></>
                                }
                                {!hasCard ? <>{addCardLink} to continue after your free trial.<br /></> : <>Add a payment method to continue after your free trial.<br /></>}
                                You won't be charged until your trial ends.
                            </p>
                                </>
                            )}
                        </div>
                    </div>
                    <div className="trial-setup-banner__divider"></div>
                    <div className="trial-setup-banner__right">
                      <div className="trial-setup-banner__right-inner">
                        <span className="trial-setup-banner__your-plan-label">Your plan</span>
                        {hasPlan && label ? (
                            <>
                                <div className="trial-setup-banner__plan-row">
                                    <span className="trial-setup-banner__plan-name">{label}</span>
                                    <span className={`badge trial-setup-banner__current-badge${isCancelling ? ' is-cancelling' : ''}`}>
                                        {isCancelling ? 'Canceling' : 'Current'}
                                    </span>
                                </div>
                                <button
                                    type="button"
                                    className="trial-setup-banner__change-plan-link btn-link"
                                    onClick={() => this.scrollToMonthlySubscription()}
                                >
                                    Change plan
                                </button>
                            </>
                        ) : nextPlanLabel ? (
                            <>
                                <div className="trial-setup-banner__plan-row">
                                    <span className="trial-setup-banner__plan-name">{nextPlanLabel}</span>
                                    <span className={`badge trial-setup-banner__current-badge${isCancelling ? ' is-cancelling' : ''}`}>
                                        {isCancelling ? 'Canceling' : 'Current'}
                                    </span>
                                </div>
                                <button
                                    type="button"
                                    className="trial-setup-banner__change-plan-link btn-link"
                                    onClick={() => this.scrollToMonthlySubscription()}
                                >
                                    Change plan
                                </button>
                            </>
                        ) : (
                            <button
                                type="button"
                                className="trial-setup-banner__change-plan-link btn-link"
                                onClick={() => this.scrollToMonthlySubscription()}
                            >
                                Choose a plan
                            </button>
                        )}
                    </div>
                </div>
                </div>
                <div className="trial-setup-banner-actions">
                    <WatchPageTutorial videoKey="billing" />
                    <div className='trial-setup-banner-actions__cancel-container'>
                        {isCancelling ? (
                            <button
                                type="button"
                                className="btn linear-gradient yr-add-new"
                                onClick={this.handleReactivateSubscription}
                                disabled={this.state.reactivateLoading}
                            >
                                <span>{this.state.reactivateLoading ? 'Reactivating...' : 'Reactivate Subscription'}</span>
                            </button>
                        ) : (
                        <button
                            type="button"
                            className="btn linear-gradient yr-add-new"
                            onClick={() => this.creditCardListRef.current && this.creditCardListRef.current.triggerCancel()}
                            disabled={!hasSubscription}
                        >
                            <span>Cancel Subscription</span>
                        </button>
                        )}
                    </div>
                    
                </div>
            </div>
        );
    }

    render() {
        // Check if user is PLG account (determined by GetPlgUsage API)
        // The API checks parent_id from zyra_user and is_plg_account from zyra_user_meta
        const isPlgAccountFinal = this.state.isPlgAccount;

        if( this.state.user.userBillingDetail.is_billing_record_available === 0){
            return (
                <>

                    <div>No Billing data is not available</div>


                </>
            )
        }else{
            return (
                <>
                    <div className="container-fluid p-0 p-lg-5 billing-css">
                        <div ref={this.myRef}></div>
                        {this.onResponseRefileModification()}
                        { this.subscriptionError( this.state ) }

                        { this.renderTrialSetupBanner() }

                           { (this.state.cardloader && this.state.creditcardsDetail )  ?
                            <CreditCardList
                                ref={this.creditCardListRef}
                                cardsList={this.state.creditcardsDetail}
                                default_card={this.state.userBillingDetail.card_number}
                                user={this.state.user}
                                billing_update={this.updateUserBillling}
                                changePrimaryCard={this.changePrimaryCard}
                                updateCards = {this.updatecard}
                                domref={this.myRef}
                                isPlgAccount={isPlgAccountFinal}
                                isInTrial={this.state.isInTrial}
                                userBillingDetail={this.state.userBillingDetail}
                                plgTwilioPhone={this.state.plgTwilioPhone}
                                plgPlan={this.state.currentPlan ?? null}
                                hideTabHeaderActions={this.trialBannerShowsActions()}
                            /> :
                            (
                            <div className="ui loading form"></div>
                            )
                           }
                        <hr className="mt-5" />

                        <div>
                         {/* Wait for GetPlgUsage (invoiceloader) so PLG users never flash Alerts & Budget */}
                            {!this.state.invoiceloader && (
                            <>
                            <div className="nav-tabs nav billing-tabs mb-3 px-4">
                                {/* Different tabs for PLG vs regular users */}
                                {isPlgAccountFinal ? (
                                    <>
                                        <a
                                            className={`nav-link tab-nav-link ${this.state.activeTab === 'currentSubscription' ? 'active' : ''}`}
                                            onClick={(e) => this.handleTabSwitch(e, 'currentSubscription')}
                                            href="#currentSubscription"
                                        >
                                            <i className="fa fa-credit-card tab-icon" aria-hidden="true"></i>
                                            Current Subscription
                                        </a>
                                        <a
                                            className={`nav-link tab-nav-link ${this.state.activeTab === 'invoiceHistory' ? 'active' : ''}`}
                                            onClick={(e) => this.handleTabSwitch(e, 'invoiceHistory')}
                                            href="#invoiceHistory"
                                        >
                                            <i className="fa fa-file-text-o tab-icon" aria-hidden="true"></i>
                                            Invoice History
                                        </a>
                                        <a
                                            className={`nav-link tab-nav-link ${this.state.activeTab === 'monthlyUsage' ? 'active' : ''}`}
                                            onClick={(e) => this.handleTabSwitch(e, 'monthlyUsage')}
                                            href="#monthlyUsage"
                                        >
                                            <i className="fa fa-bar-chart tab-icon" aria-hidden="true"></i>
                                            Monthly Usage
                                        </a>
                                    </>
                                ) : (
                                    <>
                                        <a
                                            className={`nav-link ${this.state.activeTab === 'all' ? 'active' : ''}`}
                                            onClick={(e) => this.handleTabSwitch(e, 'all')}
                                            href="#all"
                                        >
                                            All
                                        </a>
                                        <a
                                            className={`nav-link ${this.state.activeTab === 'invoiceHistory' ? 'active' : ''}`}
                                            onClick={(e) => this.handleTabSwitch(e, 'invoiceHistory')}
                                            href="#invoiceHistory"
                                        >
                                            Invoice History
                                        </a>
                                        <a
                                            className={`nav-link ${this.state.activeTab === 'monthlyUsage' ? 'active' : ''}`}
                                            onClick={(e) => this.handleTabSwitch(e, 'monthlyUsage')}
                                            href="#monthlyUsage"
                                        >
                                            Monthly Usage
                                        </a>
                                    </>
                                )}
                            </div>
                            <div className="tab-content mb-5">
                                {/* Current Subscription Tab - Only for PLG Accounts */}
                                <div
                                    className={`tab-pane fade p-2 ${
                                        this.state.activeTab === 'currentSubscription' ? 'show active' : ''
                                    } ${!isPlgAccountFinal ? 'd-none' : ''}`}
                                    id="currentSubscription"
                                >
                                    {this.state.loadedTabs['currentSubscription'] && (
                                        <div className="row px-4">
                                            {(() => {
                                                const lifecycle = resolveSubscriptionLifecycle(
                                                    this.state.userBillingDetail || {}
                                                );
                                                const isCancelling = lifecycle.state === 'cancelling';
                                                const isEnded = lifecycle.state === 'ended';
                                                const isCancelledState = isCancelling || isEnded;
                                                const showStatusPanel =
                                                    isCancelling ||
                                                    (isEnded && lifecycle.hasPreviousSubscription);
                                                const nextBillingFormatted = formatBillingDisplayDate(
                                                    lifecycle.nextBillingDate
                                                );
                                                const endDateFormatted = formatBillingDisplayDate(
                                                    lifecycle.endDate
                                                );
                                                const showThreeCards = showStatusPanel && Boolean(this.state.plgUsagePlanCode);

                                                return (
                                                    <>
                                            {/* Monthly Subscription Card */}
                                            <div className={showThreeCards ? 'col-md-4 mb-3' : 'col-md-6 col-lg-5 mb-3'} ref={this.monthlySubscriptionRef}>
                                                <div className="card shadow-sm monthly-subscription-card">
                                                    <div className="card-body p-4">
                                                        <h5 className="monthly-subscription-card__title">
                                                            Monthly Subscription
                                                        </h5>

                                                        {this.state.plansLoading && (
                                                            <div className="mb-3">
                                                                <small className="text-muted">
                                                                    <i className="fa fa-spinner fa-spin mr-1"></i>
                                                                    Loading plan details...
                                                                </small>
                                                            </div>
                                                        )}

                                                        {/* Plan dropdown */}
                                                        <div className="monthly-subscription-plan-select mb-4">
                                                            {(() => {
                                                                // Active plan takes priority; fall back to init_plan
                                                                // (trialNextPlan) when no plg_plan exists yet.
                                                                // isInTrial guard intentionally omitted — if trialNextPlan
                                                                // is set the user already saved a plan choice during trial.
                                                                const effectivePlanCode = this.state.plgUsagePlanCode
                                                                    || this.state.trialNextPlan?.plan_code
                                                                    || null;
                                                                const isInitPlanSelected = !this.state.plgUsagePlanCode && Boolean(this.state.trialNextPlan?.plan_code);

                                                                const selectedPlan = this.state.availablePlans.find(
                                                                    (p) => p.plan_code === effectivePlanCode
                                                                );
                                                                const selectedCalls = selectedPlan?.calls_included || selectedPlan?.calls || this.state.currentPlan?.calls || 0;
                                                                const selectedPrice = selectedPlan?.price || selectedPlan?.recurring_price || this.state.plgUsagePlanPrice || 0;
                                                                const hasSelectedPlan = Boolean(effectivePlanCode);
                                                                const selectedLabel = hasSelectedPlan
                                                                    ? `$${Number(selectedPrice).toFixed(0)}/mo for ${selectedCalls} AI answered calls`
                                                                    : 'Choose a plan';

                                                                return (
                                                                    <div
                                                                        className={`monthly-subscription-plan-select__wrap${this.state.planDropdownOpen ? ' is-open' : ''}`}
                                                                        onBlur={(e) => {
                                                                            if (!e.currentTarget.contains(e.relatedTarget)) {
                                                                                this.setState({ planDropdownOpen: false });
                                                                            }
                                                                        }}
                                                                    >
                                                                        <div className="monthly-subscription-plan-select__dropdown">
                                                                            <div className="monthly-subscription-plan-select__shell">
                                                                        <button
                                                                            type="button"
                                                                            id="plg_plan_dropdown"
                                                                            className="monthly-subscription-plan-select__trigger"
                                                                disabled={this.state.plansLoading}
                                                                            aria-haspopup="listbox"
                                                                            aria-expanded={this.state.planDropdownOpen}
                                                                            onClick={() => this.setState({ planDropdownOpen: !this.state.planDropdownOpen })}
                                                            >
                                                                            <span className="monthly-subscription-plan-select__left">
                                                                                <i className="fa fa-star monthly-subscription-plan-select__star" aria-hidden="true"></i>
                                                                                        <span
                                                                                            className={`monthly-subscription-plan-select__label${
                                                                                                !hasSelectedPlan ? ' is-placeholder' : ''
                                                                                            }`}
                                                                                        >
                                                                                            {selectedLabel}
                                                                                        </span>
                                                                            </span>
                                                                            <span className="monthly-subscription-plan-select__right">
                                                                                {hasSelectedPlan && (
                                                                                            <span
                                                                                                className={`monthly-subscription-plan-select__badge${
                                                                                                    isCancelling
                                                                                                        ? ' is-cancelling'
                                                                                                        : ''
                                                                                                }`}
                                                                                            >
                                                                                                {isCancelling ? 'Canceling' : 'Current'}
                                                                                    </span>
                                                                                )}
                                                                                <i className={`fa fa-chevron-${this.state.planDropdownOpen ? 'up' : 'down'} monthly-subscription-plan-select__chevron`} aria-hidden="true"></i>
                                                                            </span>
                                                                        </button>
                                                                            </div>
                                                                        {this.state.planDropdownOpen && (
                                                                            <ul className="monthly-subscription-plan-select__menu" role="listbox">
                                                                                {this.state.availablePlans.length > 0 ? (
                                                                                    this.state.availablePlans.map((plan) => {
                                                                            const calls = plan.calls_included || plan.calls || 0;
                                                                            const price = plan.price || plan.recurring_price || 0;
                                                                                        const isCurrent = plan.plan_code === this.state.plgUsagePlanCode;
                                                                                        const isInitPlan = isInitPlanSelected && plan.plan_code === effectivePlanCode;
                                                                                        return (
                                                                                            <li key={plan.plan_code} role="option" aria-selected={isCurrent || isInitPlan}>
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className={`monthly-subscription-plan-select__option${(isCurrent || isInitPlan) ? ' is-current' : ''}`}
                                                                                                    onMouseDown={(e) => e.preventDefault()}
                                                                                                    onClick={() => {
                                                                                                        this.setState({ planDropdownOpen: false });
                                                                                                        this.handlePlanChange({ target: { value: plan.plan_code } });
                                                                                                    }}
                                                                                                >
                                                                                                    <span>${Number(price).toFixed(0)}/mo for {calls} AI answered calls</span>
                                                                                                    {isCurrent && (
                                                                                                        <span className="monthly-subscription-plan-select__badge">Current</span>
                                                                                                    )}
                                                                                                    {isInitPlan && (
                                                                                                        <span className="monthly-subscription-plan-select__badge">Current</span>
                                                                                                    )}
                                                                                                </button>
                                                                                            </li>
                                                                            );
                                                                                    })
                                                                ) : (
                                                                                    <li className="monthly-subscription-plan-select__empty">No Plan Found</li>
                                                                )}
                                                                            </ul>
                                                                        )}
                                                                    </div>
                                                                        {!isCancelledState && nextBillingFormatted && (
                                                                            <div className="monthly-subscription-plan-select__next-billing">
                                                                                <i className="fa fa-calendar" aria-hidden="true"></i>
                                                                                <span>Next billing date: {nextBillingFormatted}</span>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                );
                                                            })()}
                                                            {this.state.plansError && (
                                                                <small className="text-muted d-block mt-1">
                                                                    <i className="fa fa-exclamation-circle mr-1"></i>
                                                                    Using default plans
                                                                </small>
                                                            )}
                                                            {this.state.planChangeError && !this.state.showPlanChangeModal && (
                                                                <div className="alert alert-danger mt-2 mb-0" style={{
                                                                    padding: '8px 12px',
                                                                    fontSize: '13px',
                                                                    borderRadius: '6px'
                                                                }}>
                                                                    {this.state.planChangeError}
                                                                </div>
                                                            )}
                                                        </div>

                                                        {isCancelling && (
                                                            <div className="monthly-subscription-card__cancel-alert">
                                                                <span className="monthly-subscription-card__cancel-alert-icon" aria-hidden="true">
                                                                    <i className="fa fa-info"></i>
                                                                </span>
                                                                <div className="monthly-subscription-card__cancel-alert-copy">
                                                                    <span className="monthly-subscription-card__cancel-warning">
                                                                        Your subscription will not renew.
                                                                    </span>
                                                                    {endDateFormatted && (
                                                                        <span className="monthly-subscription-card__access-note">
                                                                            Access continues until:{' '}
                                                                            <span className="monthly-subscription-card__access-date">
                                                                                {endDateFormatted}
                                                                            </span>
                                                                            .
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        )}

                                                        {/* Features list */}
                                                        <div className="monthly-subscription-features">
                                                            {[
                                                                'Free business phone line',
                                                                'SMS + Email notifications',
                                                                'Email and chat support',
                                                                'Advanced AI features'
                                                            ].map((feature) => (
                                                                <div key={feature} className="monthly-subscription-features__item">
                                                                    <img
                                                                        className="check-mark"
                                                                        src={config.imageUrl + '/assets/media/icons/check-mark.png'}
                    alt=""
                  />
                                                                    <span>{feature}</span>
                                                            </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Automatic Call Reloads Card */}
                                            {this.state.plgUsagePlanCode && (
                                            <div className={showThreeCards ? 'col-md-4 mb-3' : 'col-md-6 col-lg-4 mb-4'}>
                                                <div className="card shadow-sm" style={{border: '1px solid #e0e0e0', borderRadius: '8px', height: '100%'}}>
                                                    <div className="card-body p-4">
                                                        {(() => {
                                                            const activeAddon =
                                                                this.state.selectedAddon ||
                                                                this.state.availableAddons.find(
                                                                    (a) => a.addon_code === this.state.userBillingDetail?.addon_package
                                                                );
                                                            const addonCalls = activeAddon?.calls_included ?? 0;
                                                            const addonPrice = activeAddon?.price ?? 0;
                                                            const callUnit = addonCalls <= 1 ? 'call' : 'calls';

                                                            return (
                                                                <>
                                                                    <div className="auto-reload-card-header">
                                                                        <span className="auto-reload-title-icon" aria-hidden="true">
                                                                            <i className="fa fa-refresh"></i>
                                                                        </span>
                                                                        <div className="auto-reload-title-group" style={{marginTop:'8px'}}>
                                                                            <h5>Automatic Call Reloads</h5>
                                                                            <i
                                                                                className="fa fa-question-circle"
                                                                                style={{ fontSize: '16px', color: '#999', cursor: 'pointer' }}
                                                                                data-toggle="tooltip"
                                                                                data-placement="top"
                                                                                title="Automatically add calls when your available number of calls reaches 0. You'll be charged automatically for the selected add-on package."
                                                                            ></i>
                                                                        </div>
                                                                        <label className="switch mb-0">
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={this.state.autoReloadEnabled}
                                                                                onChange={this.handleAutoReloadToggle}
                                                                            />
                                                                            <span className="slider round"></span>
                                                                        </label>
                                                                    </div>

                                                                    <p className="text-muted mb-3" style={{ fontSize: '14px', lineHeight: '1.5' }}>
                                                                        Automatically add calls when the available number of calls in your subscription reaches 0.
                                                                    </p>

                                                                    <div className="auto-reload-select-wrap">
                                                                        <select
                                                                            className="form-control"
                                                                            style={{
                                                                                padding: '8px 15px',
                                                                                fontSize: '15px',
                                                                                border: '1px solid #d0d0d0',
                                                                                borderRadius: '6px',
                                                                                backgroundColor: '#fff',
                                                                                cursor: 'pointer',
                                                                            }}
                                                                            value={this.state.userBillingDetail.addon_package || ''}
                                                                            onChange={(e) => {
                                                                                const selectedAddonCode = e.target.value;
                                                                                if (selectedAddonCode) {
                                                                                    const addon = this.state.availableAddons.find(
                                                                                        (a) => a.addon_code === selectedAddonCode
                                                                                    );
                                                                                    if (addon) {
                                                                                        this.handleAddonSelect(addon);
                                                                                    }
                                                                                }
                                                                            }}
                                                                            disabled={
                                                                                this.state.addonsLoading ||
                                                                                !this.state.autoReloadEnabled
                                                                            }
                                                                        >
                                                                            {this.state.addonsLoading ? (
                                                                                <option>Loading add-ons...</option>
                                                                            ) : this.state.availableAddons.length > 0 ? (
                                                                                <>
                                                                                    <option value="">Select add-on</option>
                                                                                    {this.state.availableAddons.map((addon) => (
                                                                                        <option key={addon.addon_code} value={addon.addon_code}>
                                                                                            ${addon.price} for {addon.calls_included} additional {addon.calls_included <= 1 ? 'call' : 'calls'}
                                                                                        </option>
                                                                                    ))}
                                                                                </>
                                                                            ) : (
                                                                                <option value="">No add-ons available</option>
                                                                            )}
                                                                        </select>
                                                                    </div>

                                                                    {this.state.addonsError && (
                                                                        <small className="text-muted d-block mt-1 mb-2">
                                                                            <i className="fa fa-exclamation-circle mr-1"></i>
                                                                            {this.state.addonsError}
                                                                        </small>
                                                                    )}
                                                                    {this.state.addonPurchaseError && !this.state.showAddonPurchaseModal && (
                                                                        <div className="alert alert-danger mb-3" style={{
                                                                            padding: '8px 12px',
                                                                            fontSize: '13px',
                                                                            borderRadius: '6px',
                                                                        }}>
                                                                            {this.state.addonPurchaseError}
                                                                        </div>
                                                                    )}

                                                                    {activeAddon && (
                                                                        <div className="auto-reload-info-row">
                                                                            <span className="auto-reload-info-icon auto-reload-info-icon-charge" aria-hidden="true">
                                                                                <i className="fa fa-arrow-right"></i>
                                                                            </span>
                                                                            <div className="auto-reload-info-text">
                                                                                You'll be charged <strong>${Number(addonPrice).toFixed(2)}</strong> to add{' '}
                                                                                <strong>{addonCalls} {callUnit}</strong> to your account.
                                                                                <span className="auto-reload-info-subtext">
                                                                                    Charges will be billed to your saved payment method automatically.
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    )}

                                                                    <div className="auto-reload-info-row">
                                                                        <span className="auto-reload-info-icon auto-reload-info-icon-rollover" aria-hidden="true">
                                                                            <i className="fa fa-refresh"></i>
                                                                        </span>
                                                                        <div className="auto-reload-info-text">
                                                                            Unused reloaded calls will roll over to the next month.
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            );
                                                        })()}
                                                    </div>
                                                </div>
                                            </div>
                                            )}

                                            {showStatusPanel && (
                                                <div className="col-md-4 mb-3">
                                                    <div
                                                        className={`card shadow-sm subscription-ending-card${
                                                            isEnded ? ' is-ended' : ''
                                                        }`}
                                                    >
                                                        <div className="card-body p-4">
                                                            <h5 className="subscription-ending-card__title">
                                                                {isEnded ? 'Subscription Ended' : 'Subscription Ending'}
                                                            </h5>
                                                            {isCancelling ? (
                                                                <>
                                                                    <div className="subscription-ending-card__status-row">
                                                                        <span className="subscription-ending-card__calendar-icon" aria-hidden="true">
                                                                            <i className="fa fa-calendar"></i>
                                                                        </span>
                                                                        <div className="subscription-ending-card__status-text">
                                                                            <span className="subscription-ending-card__status-label">
                                                                                Your subscription will end on
                                                                            </span>
                                                                            <strong className="subscription-ending-card__status-date">
                                                                                {endDateFormatted || 'the end date'}
                                                                            </strong>
                                                                        </div>
                                                                    </div>
                                                                    <p className="subscription-ending-card__body">
                                                                        You will lose access to your subscription features after this date.
                                                                    </p>
                                                                </>
                                                            ) : (
                                                                <p className="subscription-ending-card__body subscription-ending-card__body--ended">
                                                                    Your subscription ended on{' '}
                                                                    <strong className="subscription-ending-card__status-date">
                                                                        {endDateFormatted || 'the end date'}
                                                                    </strong>
                                                                </p>
                                                            )}
                                                            <button
                                                                type="button"
                                                                className="btn linear-gradient yr-submitbtn btn-sm subscription-ending-card__reactivate"
                                                                onClick={this.handleReactivateSubscription}
                                                                disabled={this.state.reactivateLoading}
                                                            >
                                                                {this.state.reactivateLoading
                                                                    ? 'Reactivating...'
                                                                    : 'Reactivate Subscription'}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                                    </>
                                                );
                                            })()}
                                        </div>
                                    )}
                                </div>

                                {/* Complex billing details - Only for non-PLG accounts */}
                                <div
                                    className={`tab-pane fade p-2 ${
                                        this.state.activeTab === 'all' ? 'show active' : ''
                                    } ${isPlgAccountFinal ? 'd-none' : ''}`}
                                    id="all"
                                >
                                    {this.state.loadedTabs['all'] && (
                                    <>
                                    {/* {this.getsubscription_link()} */}


                                    <div className="row w-75 px-4">
                                        <div className="col-md-3">
                                            <div>
                                                <span>Voice Fee</span>
                                                <h6>${this.state.userBillingDetail.voice_monthly_fee}</h6>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div>
                                                <span>Cost Per AI Minute</span>
                                                <h6>{this.state.userBillingDetail.cost_per_minute ? "$"+this.state.userBillingDetail.cost_per_minute : 'NA'}</h6>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div>
                                                <span>Minutes Included In Plan</span>
                                                <h6>{this.state.userBillingDetail.mins_in_plan}</h6>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div>
                                                <span>Chat subscription</span>
                                                <h6>{this.state.userBillingDetail.chat_added=='y' ? 'Yes':'No'}</h6>
                                               {this.state.userBillingDetail.chat_added=='y' && <> <span>Chat Price</span><h6>${this.state.userBillingDetail.chat_amount}</h6></>}
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div>
                                                <span>Cost Per Outbound Message</span>
                                                <h6>{this.state.userBillingDetail.sms_price_per_segment ? '$' + this.state.userBillingDetail.sms_price_per_segment : 'NA'}</h6>
                                            </div>
                                        </div>
                                        {parseFloat(this.state.userBillingDetail.sms_price_per_segment) > 0 &&
                                        <div className="col-md-3">
                                            <div>
                                                <span>Outbound Messages Included in Plan</span>
                                                <h6>{this.state.userBillingDetail.outbound_messages_in_plan != null ? this.state.userBillingDetail.outbound_messages_in_plan : 'NA'}</h6>
                                            </div>
                                        </div>}
                                    </div>
                                    <hr/>

                                    <div className="row w-75 px-4">
                                        {this.state.user.is_priority=='Yes' && <div className="col-md-3">
                                            <div>
                                                <span>Priority Support</span>
                                                <h6>${this.state.userBillingDetail.priority_support_charge ? this.state.userBillingDetail.priority_support_charge:0}</h6>
                                            </div>
                                        </div>}
                                        <div className="col-md-3">
                                            <div>
                                                <span>Engage Fee</span>
                                                <h6>${ this.state.userBillingDetail.engage_fee ? this.state.userBillingDetail.engage_fee:0}</h6>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div>
                                                <span>Partner Fee</span>
                                                <h6>${ this.state.userBillingDetail.partner_fee ? this.state.userBillingDetail.partner_fee:0}</h6>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div>
                                                <span>Outbound Call</span>
                                                <h6>{this.state.userBillingDetail.is_outbound_calls=='y' ? 'Yes':'No'}</h6>
                                               {this.state.userBillingDetail.is_outbound_calls=='y' && <> <span>Outbound Call Price</span><h6>${this.state.userBillingDetail.outbound_calls_amount}</h6></>}
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                      <div className="row w-75 px-4">
                                      <div className="col-md-3">
                                            <div>
                                                <span>Invoice Date</span>
                                                <h6>{ this.state.userBillingDetail.voice_invoice_date}</h6>
                                               <p>(Usage from <span style={{color:'#1e90ff'}}>{this.state.userBillingDetail.invoice_start_date}</span> to <span style={{color:'#1e90ff'}}>{this.state.userBillingDetail.invoice_end_date}</span>)</p>

                                            </div>
                                        </div>
                                        {/* contract length */}
                                        <div className="col-md-3">
                                            <div>
                                                <span>Initial Contract Length</span>
                                                <h6>{ this.state.userBillingDetail.contract_length ? this.state.userBillingDetail.contract_length+' months' : 'N/A'}</h6>
                                               <p>(From <span style={{color:'#1e90ff'}}>{this.state.userBillingDetail?.contract_start_date ? this.state.userBillingDetail?.contract_start_date :'N/A'}</span> to <span style={{color:'#1e90ff'}}>{this.state.userBillingDetail?.contract_end_date ? this.state.userBillingDetail?.contract_end_date :'N/A'}</span>)</p>

                                            </div>
                                        </div>

                                    <div className="col-md-3">
                                            <div>
                                                <span>Last Invoice</span>
                                                <h6>${this.state.userBillingDetail.last_invoice_amount}</h6>

                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div>
                                                <span>Next Invoice </span>
                                                <span>(This amount may continue to grow)</span>
                                                <h6>${this.state.next_invoice}</h6>

                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    </>
                                    )}
                                </div>

                                {/* Invoice History tab - available for all users */}
                                <div
                                    className={`tab-pane fade p-2 ${
                                        this.state.activeTab === 'invoiceHistory' ? 'show active' : ''
                                    }`}
                                    id="invoiceHistory"
                                >
                                    {this.state.loadedTabs['invoiceHistory'] && (
                                    <>
                                    { !this.state.invoiceloader &&
                                        <Invoices invoiceHistory = {this.state.invoicesDetail} userId={this.state.user.user_id} />
                                    }
                                    {!this.state.invoicesDetail &&
                                        <React.Fragment>
                                            <h1 className="text-center text-dark py-4">
                                                <i className="fa fa-exclamation-triangle fa-2x mb-2 d-block"></i>
                                                <span>No Invoice Found</span>
                                            </h1>
                                        </React.Fragment>
                                    }
                                    </>
                                    )}
                                </div>
                                <div
                                    className={`tab-pane fade p-2 ${
                                        this.state.activeTab === 'monthlyUsage' ? 'show active' : ''
                                    }`}
                                    id="monthlyUsage"
                                >
                                    {this.state.loadedTabs['monthlyUsage'] && (
                                        <MonthlyReengage userId={this.state.user.user_id} obj={this.state} refreshKey={this.state.monthlyUsageRefreshKey} />
                                    )}
                                </div>
                            </div>
                            </>
                            )}
                        </div>
                        {/* Hide subscription cancellation for PLG accounts - they manage through simplified upgrade flow */}
                        {!this.state.invoiceloader && !isPlgAccountFinal && <div className="text-right">
                        {this.state.userBillingDetail.subscription_status=='ACTIVE' ? (
                        <Subcription_Cancellation user_subscription_id={this.state.userBillingDetail.subscription_id} user_id={this.state.userBillingDetail.user_id} subscription_status={this.state.userBillingDetail.subscription_status}  billing_update={this.updateUserBillling} type="1" text="Request Cancellation" />) : <Subcription_Cancellation user_subscription_id={this.state.userBillingDetail.subscription_id} user_id={this.state.userBillingDetail.user_id} subscription_status={this.state.userBillingDetail.subscription_status}  billing_update={this.updateUserBillling} type="2" text="Subscribe" />}

                          </div>}
                    </div>
                    {/* Hide refill modals for PLG accounts - not applicable to simplified billing */}
                    {!isPlgAccountFinal && <Modal
                        show={this.state.openRefileamountModel}
                        footer={""}
                        title={"Update Refill Amount"}
                        onclose={this.closeModal}
                        body={this.formRefilelimitModel('amount')}
                    />}
                    {!isPlgAccountFinal && <Modal
                        show={this.state.openRefilelimitModel}
                        footer={""}
                        title={"Update Refill Drop Amount"}
                        onclose={this.closeModal}
                        body={this.formRefilelimitModel('limit')}
                    />}

                    {/* PLG Plan Change Modal */}
                    {isPlgAccountFinal && this.state.selectedNewPlan && (
                        <Modal
                            show={this.state.showPlanChangeModal}
                            footer={""}
                            title={this.state.userBillingDetail?.plg_plan ? "Change your subscription?" : "Choose Your Subscription Plan"}
                            onclose={this.closePlanChangeModal}
                            maxWidth={600}
                            loading={this.state.proratedLoading}
                            body={(() => {
                                // Show loader while fetching proration
                                if (this.state.proratedLoading) {
                                    return (
                                        <div style={{textAlign: 'center', padding: '40px 0'}}>
                                            <Loader active inline='centered' size='large'>Calculating pricing...</Loader>
                                            <p style={{marginTop: '20px', color: '#666', fontSize: '14px'}}>
                                                Please wait while we calculate the prorated charges for your plan change.
                                            </p>
                                        </div>
                                    );
                                }

                                // Use backend prorated data if available, otherwise fallback to client calculation
                                const prorationData = this.state.proratedData
                                    ? this.formatBackendProration(this.state.proratedData)
                                    : this.calculateProration();

                                return (
                                <div className="plan-change-modal" style={{padding: '20px'}}>
                                    {/* Error Alert */}
                                    {this.state.planChangeError && (
                                        <div className="alert alert-danger" style={{
                                            marginBottom: '20px',
                                            padding: '12px 16px',
                                            borderRadius: '8px',
                                            fontSize: '14px'
                                        }}>
                                            <strong>Error:</strong> {this.state.planChangeError}
                                        </div>
                                    )}

                                    {/* Plan Change Summary - Simplified for Downgrade */}
                                    {this.state.isDowngrade ? (
                                        <div className="mb-4" style={{textAlign: 'center'}}>
                                            <p style={{fontSize: '16px', color: '#6b7280', lineHeight: '1.6', marginBottom: '0'}}>
                                                You're about to set the <strong style={{color: '#111'}}>{prorationData.currentCalls} calls/month</strong> to <strong style={{color: '#111'}}>{prorationData.newCalls} calls/month</strong>.
                                            </p>
                                        </div>
                                    ) : (
                                        <>
                                            <div className="mb-2" style={{textAlign: 'center'}}>
                                                {prorationData.isFirstPlan ? (
                                                    <p style={{fontSize: '13px', color: '#666', lineHeight: '1.6', marginBottom: '0', fontWeight: '600'}}>
                                                        You're about to subscribe to <strong style={{color: '#333'}}>{prorationData.newCalls} calls/month</strong> plan.
                                                    </p>
                                                ) : (
                                                    <p style={{fontSize: '13px', color: '#666', lineHeight: '1.6', marginBottom: '0', fontWeight: '600'}}>
                                                        You're about to change your plan from <strong style={{color: '#333'}}>{prorationData.currentCalls} calls/month</strong> to <strong style={{color: '#333'}}>{prorationData.newCalls} calls/month</strong>.
                                                    </p>
                                                )}
                                            </div>

                                            {/* Billing Info Message - Only for upgrades and first plan */}
                                            <div className="mb-4" style={{textAlign: 'center'}}>
                                                {prorationData.isFirstPlan ? (
                                                    <p style={{fontSize: '13px', color: '#888', lineHeight: '1.5', marginBottom: '0'}}>
                                                        You won't be charged during your trial. At the end of your trial, you'll be billed the full plan amount, and your subscription will start.
                                                    </p>
                                                ) : (
                                                    <p style={{fontSize: '13px', color: '#888', lineHeight: '1.5', marginBottom: '0'}}>
                                                        You'll be billed right away for the prorated amount, and your new monthly payment will start on <strong>{prorationData.nextBillingDateFormatted || prorationData.nextBillingDate || 'your next billing date'}</strong>.
                                                    </p>
                                                )}
                                            </div>
                                        </>
                                    )}

                                    {/* Due Today - with icon (hide for downgrades) */}
                                    {!this.state.isDowngrade && (
                                        <div className="d-flex align-items-center p-4 mb-3" style={{
                                            backgroundColor: '#f8f9fa',
                                            borderRadius: '12px',
                                            border: '1px solid #e5e7eb'
                                        }}>
                                            <div className="d-flex justify-content-center align-items-center mr-3" style={{
                                                width: '48px',
                                                height: '48px',
                                                backgroundColor: '#d1f4f5',
                                                borderRadius: '8px',
                                                flexShrink: 0
                                            }}>
                                                <i className="fa fa-calendar" style={{fontSize: '20px', color: '#17a2b8'}}></i>
                                            </div>
                                            <div className="flex-grow-1">
                                                <div style={{fontSize: '16px', fontWeight: '600', color: '#333', marginBottom: '4px'}}>
                                                    {prorationData.isFirstPlan ? 'Due at the end of your trial' : 'Due today (prorated)'}
                                                </div>
                                                <div style={{fontSize: '13px', color: '#6b7280', lineHeight: '1.5'}}>
                                                    {prorationData.isFirstPlan ? (
                                                        "At the end of your trial, you'll be charged the full plan amount to start your subscription."
                                                    ) : (
                                                        <>
                                                            You'll be billed a prorated amount for the remainder<br />
                                                            of your current billing cycle.
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                            <div style={{textAlign: 'right'}}>
                                                <div style={{fontSize: '22px', fontWeight: '700', color: '#111'}}>
                                                    ${prorationData.proratedAmount.toFixed(2)}
                                                </div>
                                                {this.state.userBillingDetail?.plg_plan && (
                                                    <div style={{fontSize: '12px', color: '#999', marginTop: '5px', display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '4px'}}>
                                                        <span>(Estimated)</span>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}

                                    {/* Monthly Subscription - with icon */}
                                    {!prorationData.isFirstPlan && (
                                        <div className="d-flex align-items-center p-4 mb-4" style={{
                                            backgroundColor: '#f8f9fa',
                                            borderRadius: '12px',
                                            border: '1px solid #e5e7eb'
                                        }}>
                                            <div className="d-flex justify-content-center align-items-center mr-3" style={{
                                                width: '48px',
                                                height: '48px',
                                                backgroundColor: '#d1f4f5',
                                                borderRadius: '8px',
                                                flexShrink: 0
                                            }}>
                                                <i className="fa fa-credit-card" style={{fontSize: '20px', color: '#17a2b8'}}></i>
                                            </div>
                                            <div className="flex-grow-1">
                                                <div style={{fontSize: '16px', fontWeight: '600', color: '#333', marginBottom: '4px'}}>
                                                    {this.state.isDowngrade ? 'New monthly subscription (from next cycle)' : 'New monthly subscription'}
                                                </div>
                                                <div style={{fontSize: '13px', color: '#6b7280', lineHeight: '1.5'}}>
                                                    {this.state.isDowngrade ? (
                                                        `Starting on ${prorationData.nextBillingDate || prorationData.nextBillingDateFormatted || 'your next billing date'}, your monthly subscription will be:`
                                                    ) : (
                                                        `Starting on ${prorationData.todayDateFormatted || new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}, your new monthly subscription will be:`
                                                    )}
                                                </div>
                                            </div>
                                            <div style={{fontSize: '22px', fontWeight: '700', color: '#111', marginLeft: '16px'}}>
                                                ${prorationData.newMonthlyPrice.toFixed(2)}
                                                <span style={{fontSize: '14px', fontWeight: '400', color: '#9ca3af'}}>/month</span>
                                            </div>
                                        </div>
                                    )}

                                    {/* Info Banner */}
                                    {!this.state.isDowngrade && (
                                        <div className="alert d-flex align-items-center mb-4" style={{
                                            backgroundColor: '#dbeafe',
                                            border: 'none',
                                            borderRadius: '8px',
                                            padding: '12px 21px'
                                        }}>
                                            <i className="fa fa-info-circle mr-2" style={{fontSize: '18px', color: '#3b82f6'}}></i>
                                            <span style={{fontSize: '11px', color: '#1e40af', lineHeight: '1.5'}}>
                                              {prorationData.isFirstPlan ? 'Changes will take effect upon the completion of your trial.' : ' Changes will take effect immediately and your new limits will be available right away.'}
                                            </span>
                                        </div>
                                    )}

                                    {/* Action Buttons */}
                                    <div className="d-flex" style={{ gap: '12px' }}>
                                        <button
                                            className="yr-cancelbtn linear-gradient-cancel btn-sm yr-btn-small"
                                            type="button"
                                            onClick={this.closePlanChangeModal}
                                            disabled={this.state.planChangeSubmitting}
                                            style={{
                                                opacity: this.state.planChangeSubmitting ? '0.6' : '1',
                                                cursor: this.state.planChangeSubmitting ? 'not-allowed' : 'pointer'
                                            }}
                                        >
                                            <span>{prorationData.isFirstPlan ? 'Cancel' : 'Keep Current Plan'}</span>
                                        </button>
                                        <button
                                            className="btn linear-gradient yr-submitbtn btn-sm"
                                            type="button"
                                            onClick={this.confirmPlanChange}
                                            disabled={this.state.planChangeSubmitting}
                                            style={{
                                                flex: '2',
                                                opacity: this.state.planChangeSubmitting ? '0.7' : '1',
                                                cursor: this.state.planChangeSubmitting ? 'not-allowed' : 'pointer'
                                                // fontSize: '15px',
                                                // fontWeight: '600',
                                                // backgroundColor: '#10b981',
                                                // color: '#fff',
                                                // border: 'none',
                                                // borderRadius: '8px'
                                            }}
                                        >
                                            {this.state.planChangeSubmitting ? (
                                                <>
                                                    <i className="fa fa-spinner fa-spin mr-2"></i>
                                                    Processing...
                                                </>
                                            ) : this.state.isDowngrade ? (
                                                'Schedule downgrade'
                                            ) : (
                                                prorationData.isFirstPlan ? 'Confirm and Create Subscription' : 'Confirm and Update Subscription'
                                            )}
                                        </button>
                                    </div>

                                    {/* Security Notice */}
                                    <div className="text-center mt-4">
                                        <p className="mb-0" style={{fontSize: '12px', color: '#9ca3af'}}>
                                            <i className="fa fa-lock mr-1"></i>
                                            Secure payment. You can cancel or change your plan anytime.
                                        </p>
                                    </div>
                                </div>
                                );
                            })()}
                        />
                    )}

                    {/* Voice Add-On Purchase Modal */}
                    {isPlgAccountFinal && this.state.selectedAddon && (
                        <Modal
                            show={this.state.showAddonPurchaseModal}
                            footer={""}
                            title={"Confirm Add-On Package Selection"}
                            onclose={this.closeAddonPurchaseModal}
                            maxWidth={550}
                            body={(() => {
                                const addon = this.state.selectedAddon;
                                return (
                                    <div className="addon-purchase-modal" style={{padding: '10px'}}>
                                        {/* Error Alert */}
                                        {this.state.addonPurchaseError && (
                                            <div className="alert alert-danger" style={{
                                                marginBottom: '20px',
                                                padding: '12px 16px',
                                                borderRadius: '6px',
                                                fontSize: '14px'
                                            }}>

                                                <strong>Error:</strong> {this.state.addonPurchaseError}
                                            </div>
                                        )}

                                        {/* Add-On Summary */}
                                        <p className="text-center mb-4" style={{fontSize: '13px', color: '#333', lineHeight: '1.5', fontWeight: '400'}}>
                                            You're about to set <strong>{addon.calls_included}-call add-on</strong> as your automatic reload preference. This add-on will be purchased automatically <strong>only when your available calls reach 0</strong>.
                                        </p>

                                        {/* Price Display */}
                                        <div className="d-flex justify-content-between align-items-center p-3 mb-3" style={{
                                            backgroundColor: '#f8f9fa',
                                            borderRadius: '8px',
                                            border: '1px solid #e0e0e0'
                                        }}>
                                            <div style={{fontSize: '15px', fontWeight: '600', color: '#333'}}>
                                                Add-On Price
                                            </div>
                                            <div style={{fontSize: '24px', fontWeight: '700', color: '#333'}}>
                                                ${addon.price.toFixed(2)}
                                            </div>
                                        </div>

                                        {/* Add-On Details */}
                                        <div className="mb-3 p-3" style={{
                                            backgroundColor: '#f8f9fa',
                                            borderRadius: '8px',
                                            border: '1px solid #e0e0e0'
                                        }}>
                                            <div className="d-flex justify-content-between mb-2">
                                                <span style={{fontSize: '14px', color: '#666', fontWeight: '400'}}>Calls Included</span>
                                                <span style={{fontSize: '14px', fontWeight: '600', color: '#333'}}>
                                                    {addon.calls_included}
                                                </span>
                                            </div>


                                                <div className="mt-2 pt-2 d-flex justify-content-between" style={{borderTop: '1px solid #e0e0e0'}}>
                                                   <span style={{fontSize: '14px', color: '#666' , fontWeight: '400'}}>Add-On Type</span>
                                                <span style={{fontSize: '14px', fontWeight: '600', color: '#333'}}>
                                                    {'Auto-Replenish'}
                                                </span>
                                                </div>

                                        </div>

                                        {/* Info Banner */}
                                        <div className="alert alert-info d-flex align-items-start mb-4" style={{
                                            backgroundColor: '#e7f3ff',
                                            border: '1px solid #b3d9ff',
                                            borderRadius: '6px',
                                            padding: '12px 16px'
                                        }}>
                                            <i className="fa fa-info-circle mr-2" style={{fontSize: '16px', color: '#0066cc', marginTop: '2px'}}></i>
                                            <span style={{fontSize: '11px', color: '#004085', lineHeight: '1.5'}}>
                                                You can change your add-on preference anytime. The selected add-on will be automatically purchased each time your available calls reach 0. Multiple add-ons can be purchased within the same billing cycle.
                                            </span>
                                        </div>

                                        {/* Action Buttons */}
                                        <div className="d-flex justify-content-end align-items-center"  style={{ gap: '12px' }}>
                                            <button
                                                className="yr-cancelbtn linear-gradient-cancel btn-sm yr-btn-small"
                                                type="button"
                                                onClick={this.closeAddonPurchaseModal}
                                                disabled={this.state.addonPurchaseSubmitting}

                                            >
                                                <span>Cancel</span>
                                            </button>
                                            <button
                                                className="btn linear-gradient yr-submitbtn btn-sm"
                                                type="button"
                                                onClick={this.confirmAddonPurchase}
                                                disabled={this.state.addonPurchaseSubmitting}
                                                style={{
                                                    padding: '10px 30px',
                                                    fontSize: '15px',
                                                    fontWeight: '500',
                                                    backgroundColor: '#17a2b8',
                                                    color: '#fff',
                                                    border: 'none',
                                                    borderRadius: '6px',
                                                    opacity: this.state.addonPurchaseSubmitting ? '0.7' : '1',
                                                    cursor: this.state.addonPurchaseSubmitting ? 'not-allowed' : 'pointer'
                                                }}
                                            >
                                                {this.state.addonPurchaseSubmitting ? (
                                                    <>
                                                        <i className="fa fa-spinner fa-spin mr-2"></i>
                                                        Saving...
                                                    </>
                                                ) : (
                                                    'Confirm and Save'
                                                )}
                                            </button>
                                        </div>


                                    </div>
                                );
                            })()}
                        />
                    )}

                    {/* Message Modal for Success/Error Messages */}
                    {this.state.showMessageModal && (
                        <Modal
                            show={this.state.showMessageModal}
                            footer={
                                <button
                                    className="btn linear-gradient yr-submitbtn btn-sm"
                                    type="button"
                                    style={{ marginTop: '16px' }}
                                    onClick={this.closeMessageModal}
                                >
                                    OK
                                </button>
                            }
                            title={this.state.messageModalTitle}
                            onclose={this.closeMessageModal}
                            maxWidth={450}
                            headerClassName="pr-5"
                            body={
                                <div className="px-4 py-2 text-left" style={{ fontSize: '14px', color: '#555', lineHeight: '1.6' }}>
                                    {this.state.messageModalMessage}
                                </div>
                            }
                        />
                    )}
                </>
            )
        }
    }
}

export default connect(null, { setUserLoggedIn })(Billing);
